import * as React from "react"
import { SVGProps } from "react"
const CardiologistAnimated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="animated"
    id="freepik_stories-cardiologist"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
    width={250}
    height={250}
  >
    <style>
      {
        "svg#freepik_stories-cardiologist:not(.animated) .animable {opacity: 0;}svg#freepik_stories-cardiologist.animated #freepik--Heart--inject-64 {animation: 1.5s Infinite  linear heartbeat;animation-delay: 0s;}            @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }"
      }
    </style>
    <g
      id="freepik--Floor--inject-64"
      style={{
        transformOrigin: "250px 359.31px 0px",
      }}
      className="animable"
    >
      <path
        id="freepik--floor--inject-64"
        d="M87.86,452.92c-89.55-51.7-89.55-135.52,0-187.22s234.73-51.7,324.28,0,89.55,135.52,0,187.22S177.41,504.62,87.86,452.92Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "250px 359.31px 0px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Shadows--inject-64"
      style={{
        transformOrigin: "245.33px 370.643px 0px",
      }}
      className="animable"
    >
      <path
        id="freepik--Shadow--inject-64"
        d="M367.24,340.52c11.69,6.83,11.69,17.89,0,24.72s-30.64,6.82-42.33,0-11.69-17.89,0-24.72S355.55,333.7,367.24,340.52Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "346.075px 352.88px 0px",
        }}
        className="animable"
      />
      <ellipse
        id="freepik--shadow--inject-64"
        cx={411.13}
        cy={420.16}
        rx={68.97}
        ry={39.82}
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "411.13px 420.16px 0px",
        }}
        className="animable"
      />
      <ellipse
        id="freepik--shadow--inject-64"
        cx={207.46}
        cy={392.25}
        rx={105.58}
        ry={60.96}
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "207.46px 392.25px 0px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-64"
        d="M174.7,281.86,11.51,376.13a1.42,1.42,0,0,0,0,2.68l47,27.08a5.13,5.13,0,0,0,4.64,0l163.18-94.28c1.28-.73,1.28-1.93,0-2.67l-47-27.08A5.11,5.11,0,0,0,174.7,281.86Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "118.925px 343.875px 0px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Plant--inject-64"
      style={{
        transformOrigin: "347.235px 293.555px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--plant--inject-64"
        style={{
          transformOrigin: "347.235px 293.555px 0px",
        }}
        className="animable"
      >
        <g
          id="freepik--Pot--inject-64"
          style={{
            transformOrigin: "347.235px 293.555px 0px",
          }}
          className="animable"
        >
          <g
            id="freepik--pot--inject-64"
            style={{
              transformOrigin: "345.938px 329.924px 0px",
            }}
            className="animable"
          >
            <path
              d="M326.67,354.56c-10.31-10.64-16.37-39.2-6.31-47.64h51.16c10.05,8.44,4,37-6.3,47.63a18.08,18.08,0,0,1-2.59,2.27,13.15,13.15,0,0,1-1.34.86c-8.48,5-22.23,5-30.71,0h0a15.13,15.13,0,0,1-1.34-.86A18.48,18.48,0,0,1,326.67,354.56Z"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "345.938px 334.175px 0px",
              }}
              id="el370z5xo82zf"
              className="animable"
            />
            <path
              d="M367.08,303.52c11.67,6.82,11.67,17.87,0,24.69s-30.6,6.81-42.28,0-11.67-17.87,0-24.68S355.4,296.71,367.08,303.52Z"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "345.938px 315.869px 0px",
              }}
              id="el7dewk113v74"
              className="animable"
            />
            <path
              d="M361.46,306.8c8.57,5,8.57,13.12,0,18.13s-22.47,5-31,0-8.58-13.12,0-18.13S352.89,301.8,361.46,306.8Z"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "345.966px 315.865px 0px",
              }}
              id="elhk5q06te5rl"
              className="animable"
            />
            <path
              d="M330.42,315.4c8.57-5,22.47-5,31,0a14.42,14.42,0,0,1,5.14,4.77,14.4,14.4,0,0,1-5.14,4.76c-8.57,5-22.47,5-31,0a14.4,14.4,0,0,1-5.14-4.76A14.42,14.42,0,0,1,330.42,315.4Z"
              style={{
                fill: "rgb(245, 245, 245)",
                transformOrigin: "345.92px 320.165px 0px",
              }}
              id="elauyi1oborlm"
              className="animable"
            />
          </g>
          <g
            id="freepik--Plants--inject-64"
            style={{
              transformOrigin: "347.235px 274.491px 0px",
            }}
            className="animable"
          >
            <path
              d="M364.62,243,349.4,255.65l14.83-7.25A41.4,41.4,0,0,1,362,262.65a91.12,91.12,0,0,0-11.48,8.53l11.38-4.8s1,7.56-1.93,19.18c-.76,3-4,8.89-6.08,13.26a49,49,0,0,1-3.2,5.83c-.07.12-.15.24-.23.36q-4-2.16-8.28-4.19c-1.94-3.84-4.56-13.38-5.61-21.21-4-30,18.37-47.74,36.52-53.93C373,225.68,366.94,233.69,364.62,243Z"
              style={{
                fill: "rgb(235, 235, 235)",
                transformOrigin: "354.595px 265.345px 0px",
              }}
              id="elm5nw3qb82vq"
              className="animable"
            />
            <g id="elohdt8d7lexr">
              <path
                d="M364.62,243,349.4,255.65l14.83-7.25A41.4,41.4,0,0,1,362,262.65a91.12,91.12,0,0,0-11.48,8.53l11.38-4.8s1,7.56-1.93,19.18c-.76,3-4,8.89-6.08,13.26a49,49,0,0,1-3.2,5.83c-.07.12-.15.24-.23.36q-4-2.16-8.28-4.19c-1.94-3.84-4.56-13.38-5.61-21.21-4-30,18.37-47.74,36.52-53.93C373,225.68,366.94,233.69,364.62,243Z"
                style={{
                  fill: "rgb(235, 235, 235)",
                  opacity: 0.05,
                  transformOrigin: "354.595px 265.345px 0px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M351.69,244.56c-3.09,3.25-4.85,7.48-6.17,11.7a61.27,61.27,0,0,0-2.46,13.07,56.39,56.39,0,0,0,3.87,26h0a.44.44,0,0,1-.24.57.43.43,0,0,1-.56-.24h0a57,57,0,0,1-3.49-26.41,61.57,61.57,0,0,1,2.68-13.1C346.71,252,348.55,247.76,351.69,244.56Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "347.01px 270.246px 0px",
              }}
              id="el9gbakaun1ac"
              className="animable"
            />
            <path
              d="M292.24,253.34l0,0c.37.53,6.44,9.1,15.16,25.52l16.43,4.05-12.46,1.14,5.73,11,16.11,4.74-13,1s2.52,12.79,11.25,18.75c4.82,3.29,7,3.54,8.89,2.62,2.31-1.13,3.65-4.63,5-9.9s.36-16.23-3.81-27.14A33,33,0,0,0,337,277C326,262.51,303.58,254.11,292.24,253.34Z"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "319.078px 287.981px 0px",
              }}
              id="el4kjh680dd5n"
              className="animable"
            />
            <path
              d="M309.22,260.23c8.3,4.49,16,10.34,21.84,17.91a45.92,45.92,0,0,1,7,12.43,43.43,43.43,0,0,1,2.49,14,0,0,0,0,1-.05.05,0,0,0,0,1,0,0,55.66,55.66,0,0,0-3.27-13.67,51.13,51.13,0,0,0-6.68-12.3c-5.61-7.56-13.14-13.57-21.3-18.28a.06.06,0,0,1,0-.07A0,0,0,0,1,309.22,260.23Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "324.885px 282.425px 0px",
              }}
              id="elin6myshoq0i"
              className="animable"
            />
            <path
              d="M402.23,255h0a40.06,40.06,0,0,0-5,.22,79.66,79.66,0,0,0-19,4.62c-2.27.84-4.55,1.8-6.78,2.87-1.12.53-2.23,1.09-3.32,1.68a55.16,55.16,0,0,0-14.53,11,34.93,34.93,0,0,0-5,7c-.17.33-.36.65-.53,1h0c-.42.87-.8,1.72-1.16,2.56-4.19,9.48-4.55,16.05-4.28,23.34.2,5.66,2.13,12.13,3.23,13.19a2.8,2.8,0,0,0,.49.36c1.61,1,4.18.43,9-2.25,9.61-5.37,13.38-19,13.38-19l-13.35-2.27,17.14-3.42,7-10.86-12.81-2.33L384.12,280c10.56-16.21,17.65-24.53,18.09-25,0,0,0,0,0,0Z"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "372.396px 289.147px 0px",
              }}
              id="elz0v4mcmvy7k"
              className="animable"
            />
            <path
              d="M397.27,255.2a79.66,79.66,0,0,0-19,4.62c-2.27.84-4.55,1.8-6.78,2.87-1.12.53-2.23,1.09-3.32,1.68a55.16,55.16,0,0,0-14.53,11,34.93,34.93,0,0,0-5,7c-.17.33-.36.65-.53,1h0c-.42.87-.8,1.72-1.16,2.56-4.19,9.48-4.55,16.05-4.28,23.34.2,5.66,2.13,12.13,3.23,13.19a2.8,2.8,0,0,0,.49.36,2.87,2.87,0,0,0,1.06.39c-1.19-8.77,3.13-31,9.66-40.15,6.79-9.51,22.91-23.31,45.07-28.07l0,0A41.38,41.38,0,0,0,397.27,255.2Z"
              style={{
                fill: "rgb(230, 230, 230)",
                transformOrigin: "372.391px 289.097px 0px",
              }}
              id="elymfyfol82ld"
              className="animable"
            />
            <path
              d="M347.42,323.22a75.6,75.6,0,0,1,1.26-19.39,62.9,62.9,0,0,1,6.43-18.39c3.29-5.72,8-10.4,13-14.54a72.49,72.49,0,0,1,16.7-10s.06,0,.08,0a0,0,0,0,1,0,.06,96,96,0,0,0-16.06,10.76,69.68,69.68,0,0,0-7.06,6.57,42.22,42.22,0,0,0-5.9,7.57,61.86,61.86,0,0,0-6.65,18.06,75.18,75.18,0,0,0-1.69,19.28,0,0,0,0,1,0,0A.05.05,0,0,1,347.42,323.22Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "366.078px 292.083px 0px",
              }}
              id="el0pdourchivj"
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="freepik--Window--inject-64"
      style={{
        transformOrigin: "430.995px 132.395px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--window--inject-64"
        style={{
          transformOrigin: "430.995px 132.395px 0px",
        }}
        className="animable"
      >
        <g
          id="freepik--window--inject-64"
          style={{
            transformOrigin: "430.995px 132.395px 0px",
          }}
          className="animable"
        >
          <g
            id="freepik--Frame--inject-64"
            style={{
              transformOrigin: "430.995px 132.395px 0px",
            }}
            className="animable"
          >
            <polygon
              points="476.88 226.83 474.45 227.66 385.08 176.06 387.5 175.23 476.88 226.83"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "430.98px 201.445px 0px",
              }}
              id="eloiaczaofmd"
              className="animable"
            />
            <polygon
              points="387.5 175.23 474.45 225.42 474.45 89.53 387.5 39.34 387.5 175.23"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "430.975px 132.38px 0px",
              }}
              id="eldok4tjx239"
              className="animable"
            />
            <path
              d="M380.51,177.57,479,234.45V88L380.5,31.14Zm4.57-139.64,89.37,51.6V227.66l-89.37-51.6Z"
              style={{
                fill: "rgb(240, 240, 240)",
                transformOrigin: "429.75px 132.795px 0px",
              }}
              id="elvsz1dz9yep"
              className="animable"
            />
            <polygon
              points="385.08 176.06 387.5 175.23 387.5 39.34 385.08 37.93 385.08 176.06"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "386.29px 106.995px 0px",
              }}
              id="elckgwoh2mp3"
              className="animable"
            />
            <polygon
              points="474.45 192.63 474.45 194.86 385.08 143.26 387.5 142.42 474.45 192.63"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "429.765px 168.64px 0px",
              }}
              id="el8mrt2cv4of3"
              className="animable"
            />
            <polygon
              points="474.45 115.97 474.45 118.2 385.08 66.6 387.5 65.76 474.45 115.97"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "429.765px 91.98px 0px",
              }}
              id="elck5hiy0pnre"
              className="animable"
            />
            <polygon
              points="380.5 31.14 382.97 30.34 481.49 87.22 479.03 88.02 380.5 31.14"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "430.995px 59.18px 0px",
              }}
              id="el3uw1byqws84"
              className="animable"
            />
            <polygon
              points="481.49 87.22 479.03 88.02 479.03 234.45 481.49 233.65 481.49 87.22"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "480.26px 160.835px 0px",
              }}
              id="elsb1ixmx7aeb"
              className="animable"
            />
            <polygon
              points="434.6 66.52 432.14 65.1 432.14 203.24 434.6 202.44 434.6 66.52"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "433.37px 134.17px 0px",
              }}
              id="el8wyn6f8axry"
              className="animable"
            />
          </g>
          <polygon
            points="427.56 62.47 432.14 65.1 432.14 203.24 427.56 200.59 427.56 62.47"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "429.85px 132.855px 0px",
            }}
            id="el1msm3kv955a"
            className="animable"
          />
          <polygon
            points="380.5 63.96 380.5 68.1 479.03 124.98 479.03 120.84 380.5 63.96"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "429.765px 94.47px 0px",
            }}
            id="elnjgij5vo67g"
            className="animable"
          />
          <polygon
            points="380.5 140.61 380.5 144.75 479.03 201.63 479.03 197.49 380.5 140.61"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "429.765px 171.12px 0px",
            }}
            id="elg522d34gvh"
            className="animable"
          />
          <polygon
            points="432.14 93.77 434.6 92.95 474.45 115.97 474.45 118.2 432.14 93.77"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "453.295px 105.575px 0px",
            }}
            id="elngovfqkeek"
            className="animable"
          />
          <polygon
            points="432.14 170.41 434.6 169.59 474.45 192.6 474.45 194.84 432.14 170.41"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "453.295px 182.215px 0px",
            }}
            id="elcik60arpeqa"
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Shelves--inject-64"
      style={{
        transformOrigin: "129.09px 88.309px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--Shelf--inject-64"
        style={{
          transformOrigin: "129.09px 107.461px 0px",
        }}
        className="animable"
      >
        <path
          d="M172.2,104.6v-3.5h0a1.18,1.18,0,0,0-.7-.94L150.45,88a3.62,3.62,0,0,0-3.24,0L86.67,123a1.22,1.22,0,0,0-.69.94h0v3.51h0a1.19,1.19,0,0,0,.69.93l21.06,12.16a3.62,3.62,0,0,0,3.24,0l60.53-34.95a1.19,1.19,0,0,0,.7-.94Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "129.09px 114.27px 0px",
          }}
          id="elvj22jtowwo"
          className="animable"
        />
        <path
          d="M86.67,124.82,107.73,137a3.56,3.56,0,0,0,3.24,0L171.5,102a1,1,0,0,0,0-1.87L150.45,88a3.62,3.62,0,0,0-3.24,0L86.67,123A1,1,0,0,0,86.67,124.82Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "129.115px 112.504px 0px",
          }}
          id="elhcwbmehyjuf"
          className="animable"
        />
        <path
          d="M109.35,137.37v3.51a3.4,3.4,0,0,1-1.62-.39L86.67,128.33a1.17,1.17,0,0,1-.69-.93h0v-3.51h0a.79.79,0,0,1,.13-.4c-.24.46-.06,1,.56,1.34L107.73,137A3.26,3.26,0,0,0,109.35,137.37Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "97.665px 132.185px 0px",
          }}
          id="elmbc4ume3obo"
          className="animable"
        />
        <path
          d="M143.48,103.7a7.76,7.76,0,0,1,6.81,0c1.88,1,1.88,2.76,0,3.81a7.76,7.76,0,0,1-6.81,0C141.6,106.46,141.6,104.75,143.48,103.7Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "146.885px 105.605px 0px",
          }}
          id="el6pb4yo9h9ay"
          className="animable"
        />
        <path
          d="M148.34,85l0-.06a4.48,4.48,0,0,0,.76-4.66,12.26,12.26,0,0,1-.59-1.64c-.26-1.08,0-2.92-1.54-2.92s-1.24,1.82-1.53,2.93a14.77,14.77,0,0,1-.58,1.56,4.48,4.48,0,0,0,.78,4.78h0a.9.9,0,0,1,.23.6h0a.88.88,0,0,1-.63.85,4.32,4.32,0,0,0-1,.42,1.91,1.91,0,0,0-1.13,1.57L142.35,105c0,1,.88,1.92,2.63,2.44a7.3,7.3,0,0,0,4.09,0c1.75-.52,2.62-1.48,2.62-2.44l-.82-16.51a1.91,1.91,0,0,0-1.13-1.57,4.4,4.4,0,0,0-1-.42.89.89,0,0,1-.63-.85h0A.89.89,0,0,1,148.34,85Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "147.02px 91.7262px 0px",
          }}
          id="ellqvzhs6d74a"
          className="animable"
        />
        <g id="elbytv99ddwig">
          <path
            d="M148.34,85l0-.06a4.48,4.48,0,0,0,.76-4.66,12.26,12.26,0,0,1-.59-1.64c-.26-1.08,0-2.92-1.54-2.92s-1.24,1.82-1.53,2.93a14.77,14.77,0,0,1-.58,1.56,4.48,4.48,0,0,0,.78,4.78h0a.9.9,0,0,1,.23.6h0a.88.88,0,0,1-.63.85,4.32,4.32,0,0,0-1,.42,1.91,1.91,0,0,0-1.13,1.57L142.35,105c0,1,.88,1.92,2.63,2.44a7.3,7.3,0,0,0,4.09,0c1.75-.52,2.62-1.48,2.62-2.44l-.82-16.51a1.91,1.91,0,0,0-1.13-1.57,4.4,4.4,0,0,0-1-.42.89.89,0,0,1-.63-.85h0A.89.89,0,0,1,148.34,85Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "147.02px 91.7262px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elm33ki3q2gc">
          <path
            d="M143.72,103.08a7.31,7.31,0,0,1,6.6,0c1.83,1,1.83,2.76,0,3.81a7.31,7.31,0,0,1-6.6,0C141.9,105.84,141.9,104.13,143.72,103.08Z"
            style={{
              fill: "rgb(240, 240, 240)",
              opacity: 0.2,
              transformOrigin: "147.024px 104.985px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elru6nm0hnf3">
          <path
            d="M148.13,107.63a7.51,7.51,0,0,0,.94-.21c1.75-.52,2.62-1.48,2.62-2.44l-.82-16.51a1.91,1.91,0,0,0-1.13-1.57,4.4,4.4,0,0,0-1-.42.89.89,0,0,1-.63-.85,1.21,1.21,0,0,0,.66,1.31c.6.39,1.59.33,1.74,2.42s.72,14.18.72,15.18S150.94,106.74,148.13,107.63Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "149.89px 96.63px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M150.88,105l-.61-12.09h0a1.59,1.59,0,0,0-1-1.32,5,5,0,0,0-4.6,0,1.61,1.61,0,0,0-.95,1.33h0l-.6,12.08a.82.82,0,0,0,.07.31,2.11,2.11,0,0,0,1.07,1.19,6,6,0,0,0,5.43,0,2.15,2.15,0,0,0,1.07-1.19A.82.82,0,0,0,150.88,105Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "147px 99.0895px 0px",
          }}
          id="eljmrbqpmpkzk"
          className="animable"
        />
        <g id="el86u38nbt1">
          <path
            d="M144.31,103.37a6,6,0,0,1,5.43,0c1.5.86,1.5,2.27,0,3.13a6,6,0,0,1-5.43,0C142.8,105.64,142.8,104.23,144.31,103.37Z"
            style={{
              opacity: 0.05,
              transformOrigin: "147.021px 104.935px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elwlix9nf1bts">
          <path
            d="M150.23,106.15l-.7-14.43-.18-.12-.73.07.73,15a2.38,2.38,0,0,0,.39-.2A2.27,2.27,0,0,0,150.23,106.15Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "149.425px 99.135px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eldm7n86tvemd">
          <path
            d="M148.13,91.82l-.47-.08.54,15.31a6.36,6.36,0,0,0,.66-.17Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "148.26px 99.395px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elthrnurrwn28">
          <path
            d="M145.4,105c.07-1.4.08-7.27.29-11.39l-.14-2.4a3.63,3.63,0,0,0-.83.35,1.61,1.61,0,0,0-.95,1.33h0l-.6,12.08a.82.82,0,0,0,.07.31,2.11,2.11,0,0,0,1.07,1.19,6,6,0,0,0,5.43,0C147.42,107.12,145.33,106.44,145.4,105Z"
            style={{
              opacity: 0.05,
              transformOrigin: "146.455px 99.1647px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M144.72,91.59a5,5,0,0,1,4.6,0c1.27.73,1.27,1.92,0,2.65a5.1,5.1,0,0,1-4.6,0C143.45,93.51,143.45,92.32,144.72,91.59Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "147.02px 92.9088px 0px",
          }}
          id="elsl12d7rqu3r"
          className="animable"
        />
        <g id="elni4ur0k4f3e">
          <path
            d="M144.72,91.59a5,5,0,0,1,4.6,0c1.27.73,1.27,1.92,0,2.65a5.1,5.1,0,0,1-4.6,0C143.45,93.51,143.45,92.32,144.72,91.59Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "147.02px 92.9088px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eludrjpfbx5jf">
          <path
            d="M146.66,101.79a7.79,7.79,0,0,0,3.44-.74,2.2,2.2,0,0,0,1.31-1.78l-.28-5.5a2.05,2.05,0,0,1-1.22,1.66,7.41,7.41,0,0,1-3.24.7Z"
            style={{
              opacity: 0.05,
              transformOrigin: "149.035px 97.7805px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M147,102a6.31,6.31,0,0,0,3.11-.75,2.17,2.17,0,0,0,1.29-1.79L151.14,94a2.06,2.06,0,0,1-1.2,1.69,6,6,0,0,1-2.92.69Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "149.2px 98.0006px 0px",
          }}
          id="elq1nv73pfl5"
          className="animable"
        />
        <g id="elq0suiw8336o">
          <path
            d="M144.13,104.59c0-.94.54-13.79.69-15.29s.7-1.85,1.69-2.61a1.14,1.14,0,0,0,.15-1.83,3.55,3.55,0,0,1-1-3.68,20,20,0,0,0,.82-3.4c.14-1.6.56-2,1.14-1.9a1.42,1.42,0,0,0-.58-.12c-1.5,0-1.24,1.82-1.53,2.93a14.77,14.77,0,0,1-.58,1.56,4.48,4.48,0,0,0,.78,4.78.9.9,0,0,1,.23.6.88.88,0,0,1-.63.85,4.32,4.32,0,0,0-1,.42,1.91,1.91,0,0,0-1.13,1.57L142.35,105c0,1,.88,1.92,2.63,2.44a7.3,7.3,0,0,0,4.09,0,6.37,6.37,0,0,0,.7-.26C145.47,108.33,144.14,105.52,144.13,104.59Z"
            style={{
              fill: "rgb(240, 240, 240)",
              opacity: 0.2,
              transformOrigin: "146.06px 91.7461px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el2bvdvby688n">
          <path
            d="M148.88,80.63c-.16-.39-.41-.76-.54-1.16a6.73,6.73,0,0,1-.23-1.61c0-.18-.05-.6-.24-.7s-.3.06-.33.21a7.07,7.07,0,0,0-.16,2.1,7.09,7.09,0,0,0,.57,1.72,6.63,6.63,0,0,1,.15,2,.65.65,0,0,0,.05.27.24.24,0,0,0,.22.14.31.31,0,0,0,.19-.13,1.63,1.63,0,0,0,.37-.5,3,3,0,0,0,.17-1.66A3.65,3.65,0,0,0,148.88,80.63Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "148.255px 80.3644px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elgnazfx87tsi">
          <path
            d="M149.32,94.24c1.27-.73,1.27-1.92,0-2.65a3.48,3.48,0,0,0-.81-.35c2.75,1,1.18,3.39-1.49,3.32-2.33-.06-3.12-1.17-3.16-1.22a1.93,1.93,0,0,0,.86.9A5.1,5.1,0,0,0,149.32,94.24Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "147.066px 93.014px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M153.7,101.19c-2.11-1.2-2.11-3.16,0-4.36a8.49,8.49,0,0,1,7.64,0c2.11,1.2,2.11,3.16,0,4.36A8.49,8.49,0,0,1,153.7,101.19Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "157.52px 99.01px 0px",
          }}
          id="el8ejp5m9tdas"
          className="animable"
        />
        <path
          d="M161.54,86.07a5,5,0,0,0-.7-.33,1.22,1.22,0,0,1-.76-1.11V82.26h-4.4v2.37a1.22,1.22,0,0,1-.76,1.11,5,5,0,0,0-.7.33,2.59,2.59,0,0,0-1.52,2.12V98.34a2.58,2.58,0,0,0,1.52,2.11,8.07,8.07,0,0,0,7.32,0,2.58,2.58,0,0,0,1.52-2.11V88.19A2.59,2.59,0,0,0,161.54,86.07Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "157.88px 91.7938px 0px",
          }}
          id="elp415lc2gurq"
          className="animable"
        />
        <g id="elzyitya0rpyk">
          <path
            d="M161.54,86.07a5,5,0,0,0-.7-.33,1.22,1.22,0,0,1-.76-1.11V82.26h-4.4v2.37a1.22,1.22,0,0,1-.76,1.11,5,5,0,0,0-.7.33,2.59,2.59,0,0,0-1.52,2.12V98.34a2.58,2.58,0,0,0,1.52,2.11,8.07,8.07,0,0,0,7.32,0,2.58,2.58,0,0,0,1.52-2.11V88.19A2.59,2.59,0,0,0,161.54,86.07Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "157.88px 91.7938px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="ellcur7rks50j">
          <path
            d="M154.22,100.46c-2-1.15-2-3,0-4.18a8.13,8.13,0,0,1,7.32,0c2,1.15,2,3,0,4.18A8.13,8.13,0,0,1,154.22,100.46Z"
            style={{
              fill: "rgb(240, 240, 240)",
              opacity: 0.2,
              transformOrigin: "157.88px 98.37px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el1k1bbtcyicn">
          <path
            d="M154.22,100.46c-2-1.15-2-3,0-4.18a8.13,8.13,0,0,1,7.32,0c2,1.15,2,3,0,4.18A8.13,8.13,0,0,1,154.22,100.46Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.88px 98.37px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M162.25,91.16V98A2.16,2.16,0,0,1,161,99.81a4.06,4.06,0,0,1-.51.26l-.09,0-.12,0a7.45,7.45,0,0,1-2.37.38,7.16,7.16,0,0,1-2.56-.45h0a2.92,2.92,0,0,1-.5-.25A2.16,2.16,0,0,1,153.51,98V91.16a2.18,2.18,0,0,1,1.28-1.78,6.8,6.8,0,0,1,6.18,0A2.18,2.18,0,0,1,162.25,91.16Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "157.88px 94.5438px 0px",
          }}
          id="elpds3pzowik"
          className="animable"
        />
        <g id="elm4d5nb3e6tk">
          <path
            d="M158.74,97.22l-.27.69a.63.63,0,0,1-1.18,0l-.27-.69A6.09,6.09,0,0,1,156.6,95V81.56h2.56V95A6.09,6.09,0,0,1,158.74,97.22Z"
            style={{
              fill: "rgb(240, 240, 240)",
              opacity: 0.15,
              transformOrigin: "157.88px 89.9395px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elsqzaz2gxmrn">
          <path
            d="M156.6,88.75V95a6.09,6.09,0,0,0,.42,2.23l.27.69a.63.63,0,0,0,1.18,0l.27-.69a6.09,6.09,0,0,0,.42-2.23V88.75A7.34,7.34,0,0,0,156.6,88.75Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.88px 93.4833px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el1oc8k9cgh7s">
          <path
            d="M157.44,98.13l.07.06.08,0,0,0,.12,0s-.22-.07-.29-.62-.21-1.93-.21-2.62V88.67a4.62,4.62,0,0,0-.65.08V95a6.09,6.09,0,0,0,.42,2.23l.27.69a.49.49,0,0,0,.1.16Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.135px 93.43px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elsvr56g5v7go">
          <path
            d="M162.25,98A2.16,2.16,0,0,1,161,99.81a4.06,4.06,0,0,1-.51.26l-.09,0-.12,0a7,7,0,0,1-4.93-.07h0a2.92,2.92,0,0,1-.5-.25,1.88,1.88,0,0,1,0-3.56,6.8,6.8,0,0,1,6.18,0A2.16,2.16,0,0,1,162.25,98Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.912px 97.9658px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eljg7sp1aqcod">
          <path
            d="M155.77,98.44V92.81l.24-1.58-1.88-1.36a1.81,1.81,0,0,0-.62,1.29V98a2.16,2.16,0,0,0,1.28,1.78,2.92,2.92,0,0,0,.5.25h0a7.16,7.16,0,0,0,2.56.45,7.45,7.45,0,0,0,2.37-.38l.12,0,.09,0,.14-.07C157.82,100.7,155.77,99.49,155.77,98.44Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.04px 95.1751px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eli4fxsl83f5">
          <path
            d="M160.65,100l.32-.17a3.15,3.15,0,0,0,.71-.54V90.5h-1Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "161.165px 95.25px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el1xxmxdziuce">
          <path
            d="M159.6,100.32a3.8,3.8,0,0,0,.51-.14V91h-.51Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "159.855px 95.66px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M159.79,88.88c1.64.49,2.46,1.39,2.46,2.28s-.82,1.79-2.46,2.28a6.71,6.71,0,0,1-3.82,0c-1.64-.49-2.46-1.39-2.46-2.28s.82-1.79,2.46-2.28A6.71,6.71,0,0,1,159.79,88.88Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "157.88px 91.16px 0px",
          }}
          id="el1cy9yu8wupa"
          className="animable"
        />
        <g id="eli0a16712j8">
          <path
            d="M159.79,88.88c1.64.49,2.46,1.39,2.46,2.28s-.82,1.79-2.46,2.28a6.71,6.71,0,0,1-3.82,0c-1.64-.49-2.46-1.39-2.46-2.28s.82-1.79,2.46-2.28A6.71,6.71,0,0,1,159.79,88.88Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "157.88px 91.16px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M159.17,91.16v2.41a7.4,7.4,0,0,1-2.57,0V91.23a.66.66,0,0,0,.37.45,2,2,0,0,0,1.82,0A.63.63,0,0,0,159.17,91.16Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "157.885px 92.4212px 0px",
          }}
          id="ele4bev6z3fvt"
          className="animable"
        />
        <g id="elc1rcnl35puv">
          <path
            d="M157,91.68a.66.66,0,0,1-.37-.45v2.34a4.62,4.62,0,0,0,.65.08V91.8A1.39,1.39,0,0,1,157,91.68Z"
            style={{
              opacity: 0.05,
              transformOrigin: "156.955px 92.44px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el5l7uepg7tew">
          <path
            d="M159.17,88.75v2.41a.63.63,0,0,1-.38.52,2,2,0,0,1-1.82,0,.66.66,0,0,1-.37-.45V88.75A7.4,7.4,0,0,1,159.17,88.75Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.885px 90.2683px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elhdrmdk0gb5s">
          <path
            d="M156.64,95.61a6,6,0,0,0,.38,1.61l.27.69a.63.63,0,0,0,1.18,0l.27-.69a6,6,0,0,0,.39-1.61A7.43,7.43,0,0,0,156.64,95.61Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.885px 96.912px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elx0xmfb9v3y">
          <path
            d="M154.37,98.37V88.5a1.43,1.43,0,0,1,.9-1.5c1.51-.77,1.71-1.4,1.71-2.17V82.26h-1.3v2.37a1.22,1.22,0,0,1-.76,1.11,5,5,0,0,0-.7.33,2.59,2.59,0,0,0-1.52,2.12V98.34a2.58,2.58,0,0,0,1.52,2.11,8.15,8.15,0,0,0,5.38.71C155.39,101.45,154.37,99.66,154.37,98.37Z"
            style={{
              fill: "rgb(240, 240, 240)",
              opacity: 0.2,
              transformOrigin: "156.15px 91.798px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elbfxmwhgbqg">
          <path
            d="M161.54,86.07a5,5,0,0,0-.7-.33,1.22,1.22,0,0,1-.76-1.11V82.26h-.48v2.83a1.33,1.33,0,0,0,.77,1c.41.23,1.73.8,2,1.43a9.33,9.33,0,0,1,.2,3.17v7.17a3.26,3.26,0,0,1-2.07,3,6,6,0,0,0,1-.45,2.54,2.54,0,0,0,1.52-2.12V88.19A2.59,2.59,0,0,0,161.54,86.07Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "161.31px 91.56px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elr6bre36m3dj">
          <path
            d="M156.6,88.75v2.48a.66.66,0,0,0,.37.45,1.39,1.39,0,0,0,.28.12V88.67A4.62,4.62,0,0,0,156.6,88.75Z"
            style={{
              opacity: 0.05,
              transformOrigin: "156.925px 90.235px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el3vba76spy2g">
          <path
            d="M158.24,98c0,.09-.16.17-.36.17s-.35-.08-.35-.17.16-.18.35-.18S158.24,97.87,158.24,98Z"
            style={{
              opacity: 0.2,
              transformOrigin: "157.885px 97.995px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el6ja4wwx1oft">
          <path
            d="M158,97.34a4.24,4.24,0,0,0,.12-1.39V81.56h-.24V96A4,4,0,0,0,158,97.34Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "158px 89.45px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elwjy8rbydh8m">
          <path
            d="M158.84,81.56h-.47V97.07h0a4.45,4.45,0,0,0,.47-2Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "158.605px 89.315px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M160.67,81.57v.69a1.36,1.36,0,0,1-.81,1.14,4.36,4.36,0,0,1-4,0,1.7,1.7,0,0,1-.61-.53,1,1,0,0,1-.21-.6v-.71a1.1,1.1,0,0,1,0-.18,1.53,1.53,0,0,1,.8-1l0,0a4.37,4.37,0,0,1,3.91,0,1.52,1.52,0,0,1,.79,1A.68.68,0,0,1,160.67,81.57Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "157.853px 81.902px 0px",
          }}
          id="elo353fgx8rbq"
          className="animable"
        />
        <path
          d="M158.11,83.17v-1c0-.41.1-1-.61-1A1.94,1.94,0,0,1,156,80.4l0,0a1.53,1.53,0,0,0-.8,1,1.1,1.1,0,0,0,0,.18v.71a1,1,0,0,0,.21.6,1.7,1.7,0,0,0,.61.53,4.36,4.36,0,0,0,4,0C159.09,83.71,158.11,83.56,158.11,83.17Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "157.608px 82.1529px 0px",
          }}
          id="elzpldgq6ids7"
          className="animable"
        />
        <path
          d="M155.91,82.7a1.2,1.2,0,0,1,0-2.28,4.43,4.43,0,0,1,4,0,1.2,1.2,0,0,1,0,2.28A4.36,4.36,0,0,1,155.91,82.7Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "157.91px 81.5643px 0px",
          }}
          id="eltdnt5hs5kij"
          className="animable"
        />
        <g id="elfykal265ti6">
          <path
            d="M155.91,82.7a1.2,1.2,0,0,1,0-2.28,4.43,4.43,0,0,1,4,0,1.2,1.2,0,0,1,0,2.28A4.36,4.36,0,0,1,155.91,82.7Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.91px 81.5643px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M160.67,79.43v1.75a.62.62,0,0,1,0,.19,1.51,1.51,0,0,1-.79,1,4,4,0,0,1-1.75.46,4.08,4.08,0,0,1-2.2-.47,1.7,1.7,0,0,1-.61-.53,1,1,0,0,1-.19-.41,1.37,1.37,0,0,1,0-.19V79.43a1.37,1.37,0,0,1,.82-1.14l.15-.08a4.4,4.4,0,0,1,3.8.08A1.38,1.38,0,0,1,160.67,79.43Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "157.902px 80.3286px 0px",
          }}
          id="elb7883mn9cee"
          className="animable"
        />
        <path
          d="M157.88,74a1.53,1.53,0,0,0-1.52,1.53v3.9h0a.76.76,0,0,0,.45.62,2.39,2.39,0,0,0,2.15,0,.75.75,0,0,0,.44-.62h0v-3.9A1.53,1.53,0,0,0,157.88,74Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "157.88px 77.1527px 0px",
          }}
          id="elq6kowfp363k"
          className="animable"
        />
        <g id="elzwo26bqg44n">
          <path
            d="M158.76,74.28h0a1.56,1.56,0,0,0-.88-.28,1.53,1.53,0,0,0-1.52,1.53v3.9h0a.76.76,0,0,0,.45.62,2.39,2.39,0,0,0,2.15,0,.93.93,0,0,0,.36-.35,1.38,1.38,0,0,1-1.28.16c-.61-.24-.79-.83-.79-1.65V75.67C157.25,74.66,158.07,73.81,158.76,74.28Z"
            style={{
              opacity: 0.05,
              transformOrigin: "157.84px 77.1527px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M158.69,77.74h0a.4.4,0,0,1-.39-.4V75.18a.4.4,0,0,1,.39-.4h0a.4.4,0,0,1,.4.4v2.16A.4.4,0,0,1,158.69,77.74Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "158.695px 76.26px 0px",
          }}
          id="elpgbumdnhu6n"
          className="animable"
        />
        <path
          d="M159.09,78.61a.4.4,0,1,1-.4-.4A.4.4,0,0,1,159.09,78.61Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "158.69px 78.61px 0px",
          }}
          id="elzo6oe934ouj"
          className="animable"
        />
        <path
          d="M155.3,81.79a1.7,1.7,0,0,0,.61.53,4.08,4.08,0,0,0,2.2.47v-.64c0-.41.12-.89-.61-1a2.88,2.88,0,0,1-1.92-1,1.41,1.41,0,0,1,.48-1.88l-.15.08a1.37,1.37,0,0,0-.82,1.14v1.76a1.37,1.37,0,0,0,0,.19A1,1,0,0,0,155.3,81.79Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "156.602px 80.5348px 0px",
          }}
          id="el9xmns8oa2of"
          className="animable"
        />
        <g id="elhrq7kny9889">
          <path
            d="M161,89.38a4.09,4.09,0,0,0-.47-.23c2.41,1.23,1.31,3.11-.17,3.8a8.84,8.84,0,0,1-5.3.11,6.87,6.87,0,0,0,5.94-.12,1.88,1.88,0,0,0,0-3.56Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "158.668px 91.4134px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          id="freepik--shadow--inject-64"
          d="M121.22,109.5c-4.17,2.41-4.17,6.32,0,8.73a16.71,16.71,0,0,0,15.12,0c4.18-2.41,4.18-6.32,0-8.73A16.71,16.71,0,0,0,121.22,109.5Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "128.784px 113.865px 0px",
          }}
          className="animable"
        />
        <g
          id="freepik--Jar--inject-64"
          style={{
            transformOrigin: "128.79px 100.304px 0px",
          }}
          className="animable"
        >
          <path
            d="M135.7,90a10.09,10.09,0,0,0-1.32-.64,2.24,2.24,0,0,1-1.44-2.08V84.71h-8.31v2.54a2.24,2.24,0,0,1-1.44,2.08,10.89,10.89,0,0,0-1.33.64C120,91.08,119,92.52,119,94v19.18c0,1.45,1,2.89,2.87,4a15.34,15.34,0,0,0,13.84,0c1.92-1.11,2.87-2.55,2.87-4V94C138.57,92.52,137.62,91.08,135.7,90Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "128.79px 101.77px 0px",
            }}
            id="el4875zzsmjcd"
            className="animable"
          />
          <g id="elu301rswidef">
            <path
              d="M122.46,116.83c-3.5-2-3.5-5.24,0-7.24a14.11,14.11,0,0,1,12.66,0c3.5,2,3.5,5.24,0,7.24A14.11,14.11,0,0,1,122.46,116.83Z"
              style={{
                opacity: 0.05,
                transformOrigin: "128.79px 113.21px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elucs9d0myqe">
            <path
              d="M133.73,87.38a10.73,10.73,0,0,0-6.65-1V84.71h-2.45v2.54a2.24,2.24,0,0,1-1.45,2.08,11.5,11.5,0,0,0-1.32.64l0,0c-1.88,1.1-2.82,2.53-2.82,4v19.18c0,1.45,1,2.89,2.87,4A15.41,15.41,0,0,0,132,118.48c-8,.54-9.88-2.83-9.88-5.27V94.56a2.8,2.8,0,0,1,.73-2.17,5.38,5.38,0,0,0,1,.7,11,11,0,0,0,9.88,0C136.46,91.51,136.46,89,133.73,87.38Z"
              style={{
                opacity: 0.05,
                transformOrigin: "127.409px 101.757px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="el3itanfvzywi">
            <path
              d="M135.7,90a10.09,10.09,0,0,0-1.32-.64,2.24,2.24,0,0,1-1.44-2.08V84.71H132v3.4a2.52,2.52,0,0,0,1.46,2c.78.43,3.26,1.51,3.87,2.69s.38,3.35.38,6V112.3a6.12,6.12,0,0,1-3.91,5.7,11,11,0,0,0,1.88-.83c1.91-1.11,2.86-2.5,2.86-4V94C138.57,92.52,137.62,91.08,135.7,90Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "135.27px 101.355px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M135.78,88.28V89a3.48,3.48,0,0,1-2.05,2.86,10.91,10.91,0,0,1-9.89,0,4.73,4.73,0,0,1-1.53-1.33A2.62,2.62,0,0,1,121.8,89v-.75a2,2,0,0,1,.06-.47,3.72,3.72,0,0,1,2-2.38l.11-.06a10.93,10.93,0,0,1,9.78.06,3.74,3.74,0,0,1,2,2.38A2,2,0,0,1,135.78,88.28Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "128.792px 88.63px 0px",
            }}
            id="el8gs922yjkl"
            className="animable"
          />
          <g id="el6lvfke6y36w">
            <path
              d="M129.36,92.29V89.72c0-1,.26.36-1.53.36-1.54,0-2.92-3.57-3.88-4.73l-.11.06a3.72,3.72,0,0,0-2,2.38,2,2,0,0,0-.06.47V89a2.62,2.62,0,0,0,.51,1.52,4.73,4.73,0,0,0,1.53,1.33,10.91,10.91,0,0,0,9.89,0C131.8,92.62,129.36,93.26,129.36,92.29Z"
              style={{
                opacity: 0.05,
                transformOrigin: "127.745px 89.1925px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M123.85,91.11c-2.73-1.57-2.73-4.13,0-5.7a10.89,10.89,0,0,1,9.88,0c2.73,1.57,2.73,4.13,0,5.7A10.89,10.89,0,0,1,123.85,91.11Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "128.79px 88.26px 0px",
            }}
            id="elo7xxm33l2j"
            className="animable"
          />
          <path
            d="M135.78,85.85V87.3a2.12,2.12,0,0,1-.06.49,3.77,3.77,0,0,1-2,2.38,9.8,9.8,0,0,1-4.37,1.16,10.37,10.37,0,0,1-5.52-1.17,4.83,4.83,0,0,1-1.53-1.33,2.45,2.45,0,0,1-.45-1,1.84,1.84,0,0,1-.06-.47V85.84a3.48,3.48,0,0,1,2-2.86l.38-.19a11,11,0,0,1,9.51.19A3.51,3.51,0,0,1,135.78,85.85Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "128.785px 86.5774px 0px",
            }}
            id="el1u0pkobwsi"
            className="animable"
          />
          <path
            d="M123.85,88.66c-2.73-1.58-2.73-4.13,0-5.71a11,11,0,0,1,9.88,0c2.73,1.58,2.73,4.13,0,5.71A11,11,0,0,1,123.85,88.66Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "128.79px 85.805px 0px",
            }}
            id="elo4zroqj3fts"
            className="animable"
          />
          <g id="el73r3svvp0tm">
            <path
              d="M122.31,88.83a4.83,4.83,0,0,0,1.53,1.33,10.37,10.37,0,0,0,5.52,1.17h0c0-.51.3-.9-1.53-1.25-1.52-.29-3.76-.92-4.81-2.59a3.52,3.52,0,0,1,1.2-4.7l-.38.19a3.48,3.48,0,0,0-2,2.86v1.48a1.84,1.84,0,0,0,.06.47A2.45,2.45,0,0,0,122.31,88.83Z"
              style={{
                opacity: 0.05,
                transformOrigin: "125.609px 87.0715px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M105.11,129.19a9.36,9.36,0,0,0,8.47,0c2.35-1.36,2.35-3.55,0-4.9a9.36,9.36,0,0,0-8.47,0C102.77,125.64,102.77,127.83,105.11,129.19Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "109.349px 126.74px 0px",
          }}
          id="elqvta87471rn"
          className="animable"
        />
        <path
          d="M104.36,105.64V126a2.48,2.48,0,0,0,1.46,2,7.82,7.82,0,0,0,7.05,0,2.48,2.48,0,0,0,1.46-2v-20.4Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "109.345px 117.22px 0px",
          }}
          id="el8yluewcvil8"
          className="animable"
        />
        <path
          d="M108.15,128.83a6.86,6.86,0,0,1-2.33-.75,2.48,2.48,0,0,1-1.46-2v-20.4h3.79Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "106.255px 117.255px 0px",
          }}
          id="el9iy93cms7em"
          className="animable"
        />
        <path
          d="M105.82,107.68a7.82,7.82,0,0,0,7.05,0c1.95-1.13,1.95-3,0-4.07a7.75,7.75,0,0,0-7.05,0C103.88,104.73,103.88,106.55,105.82,107.68Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "109.349px 105.641px 0px",
          }}
          id="el9d2q62ief9i"
          className="animable"
        />
        <path
          d="M105.73,101.68v3.56a1.8,1.8,0,0,0,1.06,1.48,5.68,5.68,0,0,0,5.11,0,1.8,1.8,0,0,0,1.06-1.48v-3.56Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "109.345px 104.504px 0px",
          }}
          id="el2v2ae24ra8n"
          className="animable"
        />
        <path
          d="M108.48,107.26a4.94,4.94,0,0,1-1.69-.54,1.8,1.8,0,0,1-1.06-1.48v-3.56h2.75Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "107.105px 104.47px 0px",
          }}
          id="elkmzcy6hkh2r"
          className="animable"
        />
        <path
          d="M106.79,103.16a5.61,5.61,0,0,0,5.11,0c1.42-.81,1.42-2.14,0-3a5.61,5.61,0,0,0-5.11,0C105.38,101,105.38,102.35,106.79,103.16Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "109.349px 101.66px 0px",
          }}
          id="elomy2135f2ki"
          className="animable"
        />
        <path
          d="M106.58,99.76v1.55a1.37,1.37,0,0,0,.81,1.13,4.28,4.28,0,0,0,3.91,0,1.37,1.37,0,0,0,.81-1.13V99.76Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "109.345px 101.336px 0px",
          }}
          id="elxn69mrjud8g"
          className="animable"
        />
        <path
          d="M108.68,102.86a3.56,3.56,0,0,1-1.29-.42,1.37,1.37,0,0,1-.81-1.13V99.76h2.1Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "107.63px 101.31px 0px",
          }}
          id="elc2t5s34ugt8"
          className="animable"
        />
        <path
          d="M107.39,100.89a4.34,4.34,0,0,0,3.91,0,1.19,1.19,0,0,0,0-2.26,4.34,4.34,0,0,0-3.91,0A1.19,1.19,0,0,0,107.39,100.89Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "109.345px 99.76px 0px",
          }}
          id="elj9p0y3xqw1"
          className="animable"
        />
        <path
          d="M107.48,96v3.62a.93.93,0,0,0,.55.76,2.92,2.92,0,0,0,2.64,0,.93.93,0,0,0,.54-.76V96Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "109.345px 98.3477px 0px",
          }}
          id="el87q6d44ivha"
          className="animable"
        />
        <path
          d="M108.48,100.56a1.63,1.63,0,0,1-.45-.18.93.93,0,0,1-.55-.76V96h1Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "107.98px 98.28px 0px",
          }}
          id="elh3191fuhgcm"
          className="animable"
        />
        <path
          d="M108,96.76a2.92,2.92,0,0,0,2.64,0,.81.81,0,0,0,0-1.53,2.92,2.92,0,0,0-2.64,0A.81.81,0,0,0,108,96.76Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "109.32px 95.995px 0px",
          }}
          id="elq0c8e58j3e"
          className="animable"
        />
        <path
          d="M110.26,98.12a.88.88,0,0,1,.41-.7c.22-.13.4,0,.4.23a.9.9,0,0,1-.4.7C110.44,98.48,110.26,98.38,110.26,98.12Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "110.665px 97.8876px 0px",
          }}
          id="elfdkwkq8gxs"
          className="animable"
        />
        <g id="elxei4o24jw1">
          <path
            d="M105.73,95.6a1.79,1.79,0,0,1,1.06-1.48,5.68,5.68,0,0,1,5.11,0A1.79,1.79,0,0,1,113,95.6v6.08a1.79,1.79,0,0,1-1.06,1.48,5.61,5.61,0,0,1-5.11,0,1.81,1.81,0,0,1-1.06-1.47h0V95.6Z"
            style={{
              fill: "rgb(250, 250, 250)",
              opacity: 0.3,
              transformOrigin: "109.365px 98.6443px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="ell1efok1ix2m">
          <path
            d="M106.79,97.07a5.61,5.61,0,0,0,5.11,0c1.42-.81,1.42-2.13,0-2.95a5.68,5.68,0,0,0-5.11,0C105.38,94.94,105.38,96.26,106.79,97.07Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "109.349px 95.5993px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <g
        id="freepik--shelf--inject-64"
        style={{
          transformOrigin: "129.09px 64.6427px 0px",
        }}
        className="animable"
      >
        <path
          d="M172.2,57.31v-3.5h0a1.18,1.18,0,0,0-.7-.94L150.45,40.71a3.62,3.62,0,0,0-3.24,0L86.67,75.66a1.22,1.22,0,0,0-.69.94h0v3.51h0a1.19,1.19,0,0,0,.69.93L107.73,93.2a3.62,3.62,0,0,0,3.24,0L171.5,58.25a1.19,1.19,0,0,0,.7-.94Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "129.09px 66.955px 0px",
          }}
          id="elw2rpiorijs"
          className="animable"
        />
        <path
          d="M86.67,77.53l21.06,12.16a3.56,3.56,0,0,0,3.24,0L171.5,54.74a1,1,0,0,0,0-1.87L150.45,40.71a3.62,3.62,0,0,0-3.24,0L86.67,75.66A1,1,0,0,0,86.67,77.53Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "129.085px 65.2036px 0px",
          }}
          id="el7kkmlswgvvb"
          className="animable"
        />
        <path
          d="M109.35,90.08v3.51a3.4,3.4,0,0,1-1.62-.39L86.67,81a1.17,1.17,0,0,1-.69-.93h0V76.6h0a.79.79,0,0,1,.13-.4c-.24.46-.06,1,.56,1.34l21.06,12.15A3.26,3.26,0,0,0,109.35,90.08Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "97.665px 84.8951px 0px",
          }}
          id="el4xbpznfq3cl"
          className="animable"
        />
        <path
          d="M143,58.91a11.76,11.76,0,0,0,10.65,0c3-1.7,3-4.46,0-6.16a11.76,11.76,0,0,0-10.65,0C140,54.45,140,57.21,143,58.91Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "148.325px 55.83px 0px",
          }}
          id="elsztg6huqcxd"
          className="animable"
        />
        <path
          d="M155.82,43.29a3.54,3.54,0,0,0-2.08-2.9,11.12,11.12,0,0,0-10.05,0,3.52,3.52,0,0,0-2.08,2.9h0V55.37h0a3.52,3.52,0,0,0,2.08,2.9,11.12,11.12,0,0,0,10.05,0,3.54,3.54,0,0,0,2.08-2.9h0Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "148.715px 49.33px 0px",
          }}
          id="ellq5ly972tvi"
          className="animable"
        />
        <g id="elt5p1rqcy3z">
          <path
            d="M153.09,40.06V58.6c.22-.1.44-.21.65-.33a5.75,5.75,0,0,0,1.13-.85V41.25a5.41,5.41,0,0,0-1.13-.86C153.53,40.27,153.31,40.16,153.09,40.06Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "153.98px 49.33px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elfk3bupqc7em">
          <path
            d="M151.23,59.21c.35-.08.69-.17,1-.28V39.74a8.51,8.51,0,0,0-1-.28Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "151.73px 49.335px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elmkay8zhb1w">
          <path
            d="M155.7,42.54A5,5,0,0,0,154,41.1a11.93,11.93,0,0,0-10-.33v-.55l-.33.17a3.52,3.52,0,0,0-2.08,2.9v2.78h0v5.32h0v4a3.52,3.52,0,0,0,2.08,2.9,11.12,11.12,0,0,0,10.05,0,5,5,0,0,0,1.26-1c-1.32,1.24-4.61,1.91-7.05,1.43s-3.93-2-3.93-3.14V54.49a10.66,10.66,0,0,0,4.92,1.09V50.17a10.63,10.63,0,0,1-4.92-1V47.58a11.93,11.93,0,0,0,10-.33,4.85,4.85,0,0,0,1.78-1.64V43.29A2.45,2.45,0,0,0,155.7,42.54Z"
            style={{
              opacity: 0.05,
              transformOrigin: "148.686px 49.6598px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elxr6q32kzize">
          <path
            d="M142.81,55.88V41a3.06,3.06,0,0,0-1.2,2.28V55.37a3.52,3.52,0,0,0,2.08,2.9,8.58,8.58,0,0,0,2.7,1C143.72,58.52,142.81,56.7,142.81,55.88Z"
            style={{
              opacity: 0.05,
              transformOrigin: "144px 50.135px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M156.25,40.05A3.75,3.75,0,0,0,154,37a11.78,11.78,0,0,0-10.66,0,3.73,3.73,0,0,0-2.2,3.08h0v3.34h0a3.73,3.73,0,0,0,2.2,3.07,11.78,11.78,0,0,0,10.66,0,3.75,3.75,0,0,0,2.21-3.07h0V40.05Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "148.695px 41.745px 0px",
          }}
          id="elnlz8pwbd5vm"
          className="animable"
        />
        <g id="elsdly477dg3">
          <g
            style={{
              opacity: 0.1,
              transformOrigin: "148.715px 43.57px 0px",
            }}
            className="animable"
          >
            <path
              d="M151.33,43.11H151v4.41l.36-.06Z"
              id="ela02cu8ht17j"
              style={{
                transformOrigin: "151.18px 45.315px 0px",
              }}
              className="animable"
            />
            <path
              d="M149.66,47.69V43.31h-.36v4.4Z"
              id="elhkb8iksf2iv"
              style={{
                transformOrigin: "149.48px 45.51px 0px",
              }}
              className="animable"
            />
            <path
              d="M155.6,45.13v-4h-.36v4.39A4.48,4.48,0,0,0,155.6,45.13Z"
              id="ellikhl6jspi"
              style={{
                transformOrigin: "155.42px 43.325px 0px",
              }}
              className="animable"
            />
            <path
              d="M156.07,44.3a2.68,2.68,0,0,0,.18-.91V40.05a2.87,2.87,0,0,0-.05-.31h-.13Z"
              id="elua5gwewmopr"
              style={{
                transformOrigin: "156.16px 42.02px 0px",
              }}
              className="animable"
            />
            <path
              d="M154,46.49s0,0,.06,0a2.28,2.28,0,0,0,.3-.21V42.11H154Z"
              id="el5nceoh06de6"
              style={{
                transformOrigin: "154.18px 44.3px 0px",
              }}
              className="animable"
            />
            <path
              d="M152.91,42.71h-.37v4.41c.12,0,.25-.07.37-.12Z"
              id="elnmptf7o0rs"
              style={{
                transformOrigin: "152.725px 44.915px 0px",
              }}
              className="animable"
            />
            <path
              d="M144.76,47.08V42.64h-.36v4.3A3,3,0,0,0,144.76,47.08Z"
              id="elllvpdl7mkc"
              style={{
                transformOrigin: "144.58px 44.86px 0px",
              }}
              className="animable"
            />
            <path
              d="M141.87,45.19a4.43,4.43,0,0,0,.37.39V41h-.37Z"
              id="elhcjxymzdkm"
              style={{
                transformOrigin: "142.055px 43.29px 0px",
              }}
              className="animable"
            />
            <path
              d="M141.18,40.05v3.34h0a2.68,2.68,0,0,0,.18.91V39.43h-.08a2.59,2.59,0,0,0-.1.62Z"
              id="el940vg4kym8"
              style={{
                transformOrigin: "141.27px 41.865px 0px",
              }}
              className="animable"
            />
            <path
              d="M143,46.19c.12.08.23.17.36.25v-4.5H143Z"
              id="el4o8bz9oat4n"
              style={{
                transformOrigin: "143.18px 44.19px 0px",
              }}
              className="animable"
            />
            <path
              d="M148,43.3h-.36v4.38l.36,0Z"
              id="el2kvjs7bssn3"
              style={{
                transformOrigin: "147.82px 45.49px 0px",
              }}
              className="animable"
            />
            <path
              d="M146.31,43.08H146v4.35c.11,0,.24,0,.36.06Z"
              id="elq0bhaey8elf"
              style={{
                transformOrigin: "146.18px 45.285px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el1c2utmita86">
          <path
            d="M150.52,47.61c-3.73,0-5.7-1.19-6.3-2.18a7.84,7.84,0,0,1-.53-3.52s-.42-3.13-.34-3.14-.89-.21-1.62-.36a2.81,2.81,0,0,0-.55,1.64h0v3.34h0a3.73,3.73,0,0,0,2.2,3.07A11.62,11.62,0,0,0,150.52,47.61Z"
            style={{
              opacity: 0.05,
              transformOrigin: "145.85px 43.0812px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M143.38,43.12a11.78,11.78,0,0,0,10.66,0c3-1.7,3-4.45,0-6.15a11.78,11.78,0,0,0-10.66,0C140.44,38.67,140.44,41.42,143.38,43.12Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "148.733px 40.045px 0px",
          }}
          id="el0unwhvjn7iw"
          className="animable"
        />
        <path
          d="M154.45,42.87c2.52-1.71,2.39-4.28-.41-5.9a10.76,10.76,0,0,0-5.18-1.27,8.2,8.2,0,0,0-2.75.94c-2.55,1.45-2.55,4.36,0,5.81A10.45,10.45,0,0,0,154.45,42.87Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "150.221px 39.621px 0px",
          }}
          id="el7tqa1ib62l"
          className="animable"
        />
        <g id="elt82xffbwkyn">
          <path
            d="M144.1,58a11.57,11.57,0,0,0,9.23,0c2.55-1.28,2.55-3.36,0-4.64a11.57,11.57,0,0,0-9.23,0C141.55,54.59,141.55,56.67,144.1,58Z"
            style={{
              opacity: 0.05,
              transformOrigin: "148.715px 55.68px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M141.61,46.42a3.52,3.52,0,0,0,2.08,2.9,10.27,10.27,0,0,0,5,1.2v5.33a10.27,10.27,0,0,1-5-1.2,3.52,3.52,0,0,1-2.08-2.9Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "145.15px 51.1358px 0px",
          }}
          id="elpazc01ew2o"
          className="animable"
        />
        <path
          d="M141.75,41.72a10.07,10.07,0,0,0,7.19,2.34c4.74-.13,6.63-2.72,6.88-3.52a3,3,0,0,0-.64-2.73,3.18,3.18,0,0,1,1.07,2.24v3.34c0,.28.15,1.25-1.38,2.51a3.72,3.72,0,0,0,.89-2V41.59s-1.67,2.81-6.82,2.81S142,42.14,141.75,41.72Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "149.002px 41.855px 0px",
          }}
          id="el09gjfqkg51gd"
          className="animable"
        />
        <path
          d="M128.59,66.18a11.78,11.78,0,0,0,10.66,0c2.94-1.7,2.94-4.45,0-6.15a11.78,11.78,0,0,0-10.66,0C125.64,61.73,125.64,64.48,128.59,66.18Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "133.916px 63.105px 0px",
          }}
          id="elc00wyqmjsd7"
          className="animable"
        />
        <path
          d="M141.43,50.57a3.52,3.52,0,0,0-2.08-2.9,11.12,11.12,0,0,0-10,0,3.52,3.52,0,0,0-2.08,2.9h0V62.65h0a3.52,3.52,0,0,0,2.08,2.9,11.12,11.12,0,0,0,10,0,3.52,3.52,0,0,0,2.08-2.9h0Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "134.35px 56.61px 0px",
          }}
          id="el4saa02dalg"
          className="animable"
        />
        <g id="el8t8urdxyhnh">
          <path
            d="M138.7,47.34V65.88c.22-.1.44-.21.65-.33a5.41,5.41,0,0,0,1.13-.86V48.53a5.41,5.41,0,0,0-1.13-.86C139.14,47.55,138.92,47.44,138.7,47.34Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "139.59px 56.61px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elrjrvuxf030g">
          <path
            d="M136.84,66.48a8.51,8.51,0,0,0,1-.28V47a8.51,8.51,0,0,0-1-.28Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.4,
              transformOrigin: "137.34px 56.6px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elbekxt6e2l5">
          <path
            d="M141.31,49.81a5.08,5.08,0,0,0-1.66-1.43,11.9,11.9,0,0,0-10-.33v-.56l-.34.18a3.52,3.52,0,0,0-2.08,2.9v2.78h0v5.32h0v4a3.52,3.52,0,0,0,2.08,2.9,11.12,11.12,0,0,0,10,0,5.28,5.28,0,0,0,1.27-1c-1.33,1.23-4.62,1.91-7.06,1.43s-3.92-2-3.92-3.15V61.77a10.62,10.62,0,0,0,4.91,1.09V57.45a10.59,10.59,0,0,1-4.91-1V54.86a11.9,11.9,0,0,0,10-.33,4.85,4.85,0,0,0,1.78-1.64V50.57A2.51,2.51,0,0,0,141.31,49.81Z"
            style={{
              opacity: 0.05,
              transformOrigin: "134.307px 56.932px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elthkbqh62mw9">
          <path
            d="M128.42,63.16V48.29a3,3,0,0,0-1.2,2.28V62.65a3.52,3.52,0,0,0,2.08,2.9,8.84,8.84,0,0,0,2.7,1C129.33,65.8,128.42,64,128.42,63.16Z"
            style={{
              opacity: 0.05,
              transformOrigin: "129.61px 57.42px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M141.86,47.32a3.75,3.75,0,0,0-2.21-3.07,11.76,11.76,0,0,0-10.65,0,3.73,3.73,0,0,0-2.21,3.07h0v3.35h0A3.73,3.73,0,0,0,129,53.74a11.76,11.76,0,0,0,10.65,0,3.75,3.75,0,0,0,2.21-3.07h0V47.32Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "134.325px 48.995px 0px",
          }}
          id="el8t4r5hf2w8b"
          className="animable"
        />
        <g id="elc5wcp987wnm">
          <g
            style={{
              opacity: 0.1,
              transformOrigin: "134.325px 50.855px 0px",
            }}
            className="animable"
          >
            <path
              d="M136.94,50.39h-.36V54.8l.36-.06Z"
              id="elvudvamh2bcn"
              style={{
                transformOrigin: "136.76px 52.595px 0px",
              }}
              className="animable"
            />
            <path
              d="M135.27,55V50.59h-.36V55Z"
              id="ellwcea33z7g"
              style={{
                transformOrigin: "135.09px 52.795px 0px",
              }}
              className="animable"
            />
            <path
              d="M141.21,52.41v-4h-.36v4.39A3.33,3.33,0,0,0,141.21,52.41Z"
              id="elhpalk2li4i"
              style={{
                transformOrigin: "141.03px 50.605px 0px",
              }}
              className="animable"
            />
            <path
              d="M141.68,51.58a2.68,2.68,0,0,0,.18-.91V47.32c0-.1,0-.2-.05-.3h-.13Z"
              id="el67iy3ub0gxp"
              style={{
                transformOrigin: "141.77px 49.3px 0px",
              }}
              className="animable"
            />
            <path
              d="M139.59,53.77l.06,0a2.28,2.28,0,0,0,.3-.21V49.38h-.36Z"
              id="elrzmkn6srni"
              style={{
                transformOrigin: "139.77px 51.575px 0px",
              }}
              className="animable"
            />
            <path
              d="M138.52,50h-.36V54.4l.36-.12Z"
              id="elosrgh27s3ur"
              style={{
                transformOrigin: "138.34px 52.2px 0px",
              }}
              className="animable"
            />
            <path
              d="M130.37,54.36V49.91H130v4.31Z"
              id="eltejx2akl3cb"
              style={{
                transformOrigin: "130.185px 52.135px 0px",
              }}
              className="animable"
            />
            <path
              d="M127.49,52.46a3.33,3.33,0,0,0,.36.4v-4.6h-.36Z"
              id="elmlkyc0oblw"
              style={{
                transformOrigin: "127.67px 50.56px 0px",
              }}
              className="animable"
            />
            <path
              d="M126.79,47.32v3.35h0a2.68,2.68,0,0,0,.18.91V46.71h-.08a2.59,2.59,0,0,0-.1.61Z"
              id="elkvdpb53dukf"
              style={{
                transformOrigin: "126.88px 49.145px 0px",
              }}
              className="animable"
            />
            <path
              d="M128.6,53.46c.13.09.23.18.36.26v-4.5h-.36Z"
              id="elkbh6igsrka9"
              style={{
                transformOrigin: "128.78px 51.47px 0px",
              }}
              className="animable"
            />
            <path
              d="M133.57,50.58h-.36V55l.36,0Z"
              id="elvpvmqf1tx3q"
              style={{
                transformOrigin: "133.39px 52.79px 0px",
              }}
              className="animable"
            />
            <path
              d="M131.92,50.36h-.36v4.35c.11,0,.24,0,.36.06Z"
              id="elu3zqdb9sl6e"
              style={{
                transformOrigin: "131.74px 52.565px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el5z9149s4chj">
          <path
            d="M136.13,54.89c-3.73,0-5.7-1.19-6.3-2.18a7.86,7.86,0,0,1-.53-3.52s-.42-3.13-.34-3.14-.89-.21-1.62-.36a2.8,2.8,0,0,0-.55,1.63h0v3.35h0A3.73,3.73,0,0,0,129,53.74,11.58,11.58,0,0,0,136.13,54.89Z"
            style={{
              opacity: 0.05,
              transformOrigin: "131.46px 50.3614px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M129,50.4a11.76,11.76,0,0,0,10.65,0c2.95-1.7,2.95-4.45,0-6.15a11.76,11.76,0,0,0-10.65,0C126.05,46,126.05,48.7,129,50.4Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "134.325px 47.325px 0px",
          }}
          id="el3kabkrm0se5"
          className="animable"
        />
        <path
          d="M140.06,50.14c2.52-1.71,2.39-4.28-.41-5.89A10.76,10.76,0,0,0,134.47,43a8.42,8.42,0,0,0-2.75.93c-2.54,1.46-2.54,4.36,0,5.82A10.41,10.41,0,0,0,140.06,50.14Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "135.835px 46.9141px 0px",
          }}
          id="elrufjvf0zci7"
          className="animable"
        />
        <g id="elydhxfeqpqh">
          <path
            d="M129.71,65.23a11.57,11.57,0,0,0,9.23,0c2.55-1.28,2.55-3.36,0-4.64a11.57,11.57,0,0,0-9.23,0C127.16,61.87,127.16,64,129.71,65.23Z"
            style={{
              opacity: 0.05,
              transformOrigin: "134.325px 62.91px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M127.22,53.7a3.52,3.52,0,0,0,2.08,2.9,10.29,10.29,0,0,0,5,1.2v5.33a10.19,10.19,0,0,1-5-1.21,3.52,3.52,0,0,1-2.08-2.9Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "130.76px 58.4158px 0px",
          }}
          id="el46amklsy6q6"
          className="animable"
        />
        <path
          d="M127.36,49a10.12,10.12,0,0,0,7.19,2.33c4.74-.13,6.63-2.71,6.88-3.51a3,3,0,0,0-.64-2.73,3.14,3.14,0,0,1,1.07,2.23v3.35c0,.28.15,1.25-1.38,2.51a3.72,3.72,0,0,0,.89-2V48.87s-1.67,2.8-6.82,2.8S127.62,49.42,127.36,49Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "134.612px 49.135px 0px",
          }}
          id="elv6rl7aiae2"
          className="animable"
        />
        <path
          id="freepik--shadow--inject-64"
          d="M104.94,69c-4.18,2.41-4.18,6.32,0,8.73a16.71,16.71,0,0,0,15.12,0c4.18-2.41,4.18-6.32,0-8.73A16.71,16.71,0,0,0,104.94,69Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "112.5px 73.365px 0px",
          }}
          className="animable"
        />
        <g
          id="freepik--jar--inject-64"
          style={{
            transformOrigin: "112.5px 59.7841px 0px",
          }}
          className="animable"
        >
          <path
            d="M119.42,49.45a10.75,10.75,0,0,0-1.32-.64,2.25,2.25,0,0,1-1.45-2.08V44.18h-8.3v2.55a2.26,2.26,0,0,1-1.45,2.08,10.75,10.75,0,0,0-1.32.64c-1.92,1.1-2.87,2.55-2.87,4V72.63c0,1.44,1,2.89,2.87,4a15.27,15.27,0,0,0,13.84,0c1.91-1.1,2.87-2.55,2.87-4V53.44C122.29,52,121.33,50.55,119.42,49.45Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "112.5px 61.234px 0px",
            }}
            id="el5lzblbxv5p6"
            className="animable"
          />
          <g id="elfgf193x52uj">
            <path
              d="M106.17,76.31c-3.49-2-3.49-5.24,0-7.24a14.11,14.11,0,0,1,12.66,0c3.5,2,3.5,5.24,0,7.24A14.19,14.19,0,0,1,106.17,76.31Z"
              style={{
                opacity: 0.05,
                transformOrigin: "112.504px 72.6853px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="eliskizkmfqrh">
            <path
              d="M117.45,46.86a10.78,10.78,0,0,0-6.66-1.06V44.18h-2.44v2.55a2.26,2.26,0,0,1-1.45,2.08,10.75,10.75,0,0,0-1.32.64l0,0c-1.88,1.1-2.82,2.53-2.82,4V72.63c0,1.44,1,2.89,2.87,4A15.26,15.26,0,0,0,115.74,78c-7.95.55-9.87-2.82-9.87-5.26V54a2.83,2.83,0,0,1,.72-2.17,5.25,5.25,0,0,0,1,.7,10.91,10.91,0,0,0,9.89,0C120.18,51,120.18,48.44,117.45,46.86Z"
              style={{
                opacity: 0.05,
                transformOrigin: "111.131px 61.2516px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elno7s6kkzv7p">
            <path
              d="M119.42,49.45a10.75,10.75,0,0,0-1.32-.64,2.25,2.25,0,0,1-1.45-2.08V44.18h-.91v3.41a2.51,2.51,0,0,0,1.46,1.95c.78.43,3.27,1.51,3.87,2.69s.39,3.36.39,6V71.78a6.14,6.14,0,0,1-3.91,5.7,11,11,0,0,0,1.87-.84c1.91-1.1,2.87-2.49,2.87-4V53.44C122.29,52,121.33,50.55,119.42,49.45Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "119.015px 60.83px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M119.49,47.75v.73a3.44,3.44,0,0,1-2,2.86,11,11,0,0,1-9.88,0A4.64,4.64,0,0,1,106,50a2.59,2.59,0,0,1-.51-1.51v-.75a1.88,1.88,0,0,1,0-.47,3.76,3.76,0,0,1,2-2.39l.1-.05a11,11,0,0,1,9.78.05,3.75,3.75,0,0,1,2,2.38A2.09,2.09,0,0,1,119.49,47.75Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "112.483px 48.1099px 0px",
            }}
            id="elr9qw61bega"
            className="animable"
          />
          <g id="elpd20v9hkqpr">
            <path
              d="M113.08,51.77V49.2c0-1,.25.36-1.53.36-1.55,0-2.93-3.57-3.89-4.73l-.1.05a3.76,3.76,0,0,0-2,2.39,1.88,1.88,0,0,0,0,.47v.75A2.59,2.59,0,0,0,106,50a4.64,4.64,0,0,0,1.53,1.34,11,11,0,0,0,9.88,0C115.52,52.1,113.08,52.74,113.08,51.77Z"
              style={{
                opacity: 0.05,
                transformOrigin: "111.478px 48.6708px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M107.56,50.59c-2.73-1.58-2.73-4.13,0-5.71a11,11,0,0,1,9.89,0c2.72,1.58,2.72,4.13,0,5.71A11,11,0,0,1,107.56,50.59Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "112.501px 47.735px 0px",
            }}
            id="elj4zoe5rcnzg"
            className="animable"
          />
          <path
            d="M119.49,45.33v1.44a2,2,0,0,1,0,.49,3.73,3.73,0,0,1-2,2.38,9.54,9.54,0,0,1-4.36,1.16,10.32,10.32,0,0,1-5.52-1.16A4.74,4.74,0,0,1,106,48.31a2.66,2.66,0,0,1-.46-1,1.93,1.93,0,0,1,0-.47V45.32a3.48,3.48,0,0,1,2-2.86c.12-.07.24-.14.37-.2a11,11,0,0,1,9.51.2A3.44,3.44,0,0,1,119.49,45.33Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "112.515px 46.0508px 0px",
            }}
            id="elogdv9n31gvk"
            className="animable"
          />
          <path
            d="M107.56,48.13c-2.73-1.57-2.73-4.13,0-5.7a10.91,10.91,0,0,1,9.89,0c2.72,1.57,2.72,4.13,0,5.7A10.91,10.91,0,0,1,107.56,48.13Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "112.501px 45.28px 0px",
            }}
            id="elj0hkivrsuz8"
            className="animable"
          />
          <g id="el07diwfgmqb46">
            <path
              d="M106,48.31a4.74,4.74,0,0,0,1.53,1.33,10.32,10.32,0,0,0,5.52,1.16h0c0-.5.3-.89-1.53-1.24-1.52-.3-3.77-.93-4.82-2.59a3.54,3.54,0,0,1,1.2-4.71c-.13.06-.25.13-.37.2a3.48,3.48,0,0,0-2,2.86V46.8a1.93,1.93,0,0,0,0,.47A2.66,2.66,0,0,0,106,48.31Z"
              style={{
                opacity: 0.05,
                transformOrigin: "109.292px 46.5425px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="freepik--Diplomas--inject-64"
      style={{
        transformOrigin: "45.935px 111.965px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--Picture--inject-64"
        style={{
          transformOrigin: "45.935px 77.03px 0px",
        }}
        className="animable"
      >
        <polygon
          points="22.3 65.33 24.19 66.41 24.19 114.93 22.3 113.85 22.3 65.33"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "23.245px 90.13px 0px",
          }}
          id="eliytdwa9fswk"
          className="animable"
        />
        <polygon
          points="25.85 107.72 27.72 108.83 66.05 86.7 64.18 85.58 25.85 107.72"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "45.95px 97.205px 0px",
          }}
          id="elv6cbof7alu"
          className="animable"
        />
        <path
          d="M69.57,40.21,24.19,66.41v48.52l45.38-26.2ZM66.05,86.7,27.72,108.83V68.45L66.05,46.32Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "46.88px 77.57px 0px",
          }}
          id="elbj13wr8imv"
          className="animable"
        />
        <polygon
          points="66.05 86.7 64.18 85.58 64.18 47.41 66.05 46.32 66.05 86.7"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "65.115px 66.51px 0px",
          }}
          id="el68gml9bhme"
          className="animable"
        />
        <polygon
          points="69.57 40.21 67.68 39.13 22.3 65.33 24.19 66.41 69.57 40.21"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "45.935px 52.77px 0px",
          }}
          id="ellkh75prda1b"
          className="animable"
        />
        <path
          d="M48.84,73.08h0s0,0-.06,0,0,0,0,0h.05S48.84,73.07,48.84,73.08Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "48.7967px 73.0778px 0px",
          }}
          id="el3jetfvywzl8"
          className="animable"
        />
        <polygon
          points="64.18 85.58 27.72 106.63 27.72 68.45 64.18 47.41 64.18 85.58"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "45.95px 77.02px 0px",
          }}
          id="elrmwmtd3fxfr"
          className="animable"
        />
        <path
          d="M59,77.5c1.66-1,3-.18,3,1.74a6.65,6.65,0,0,1-3,5.21c-1.66,1-3,.18-3-1.74A6.65,6.65,0,0,1,59,77.5Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "59px 80.975px 0px",
          }}
          id="elo7fid33bar"
          className="animable"
        />
        <path
          d="M34.63,69.66,57.29,56.57c.63-.36,1.14-.07,1.14.66v.07a2.52,2.52,0,0,1-1.14,2L34.63,72.38c-.63.36-1.14.07-1.14-.66v-.08A2.53,2.53,0,0,1,34.63,69.66Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "45.96px 64.475px 0px",
          }}
          id="elu3lqsi5mm7"
          className="animable"
        />
        <path
          d="M31,80,60.87,62.76c.63-.37,1.14-.2,1.14.37a2.29,2.29,0,0,1-1.14,1.69L31,82.05c-.63.36-1.14.19-1.13-.38A2.32,2.32,0,0,1,31,80Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "45.9399px 72.4013px 0px",
          }}
          id="elvr2djj5svhe"
          className="animable"
        />
        <path
          d="M31,84.09,60.87,66.87c.63-.36,1.14-.2,1.14.37a2.28,2.28,0,0,1-1.14,1.69L31,86.16c-.63.36-1.14.2-1.13-.38A2.32,2.32,0,0,1,31,84.09Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "45.9399px 76.5148px 0px",
          }}
          id="el9g3fqt6pe8s"
          className="animable"
        />
        <path
          d="M31,88.2,60.87,71c.63-.36,1.14-.19,1.14.37A2.28,2.28,0,0,1,60.87,73L31,90.27c-.63.37-1.14.2-1.13-.37A2.33,2.33,0,0,1,31,88.2Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "45.9399px 80.6384px 0px",
          }}
          id="elwjrze43xgmj"
          className="animable"
        />
        <path
          d="M53.59,86.31a1.69,1.69,0,0,1-.74.19c-.64,0-.58-.65-.56-1.09,0-.21-.27-.52-.42-.25-.38.7-.88,1.34-1.29,2-.26.42-.74,1.36-1.35,1.22-.26-.05-.34-.33-.34-.67a3.32,3.32,0,0,0,.4-1.86c0-.19-.35-.43-.46-.17a6.11,6.11,0,0,0-.38,1.72,10.54,10.54,0,0,1-1,1.43c-.2.28-.39.58-.61.84-.06.06-.16.22-.25.24s-.19-.09-.22-.23a1.43,1.43,0,0,1,.1-.61h0s0,0,0,0h0c0-.2-.26-.5-.37-.25a9.05,9.05,0,0,1-1.75,2.92l-.11.09c0-.12,0-.24-.05-.36a2.81,2.81,0,0,0-.14-.81c-.05-.13-.28-.33-.4-.15a13.76,13.76,0,0,1-2,2.74,3.23,3.23,0,0,1-.42.29c-.13-.08.08-.8.1-.91.08-.32.19-.64.3-1a4,4,0,0,0,.24-.79c0-.24-.39-.62-.46-.29l-.28.86a20.72,20.72,0,0,1-1.67,2.84,6.5,6.5,0,0,1-2.33,2.24c-.27.15-.76.35-1,.14s-.26-.57-.27-.84a6.93,6.93,0,0,1,.27-2.07,12,12,0,0,0,2.59-1.82,8.58,8.58,0,0,0,2-2.17c.27-.47.43-1.26-.21-1.53-.45-.19-1,.12-1.4.33a5.86,5.86,0,0,0-1.42,1.11,8.15,8.15,0,0,0-1.78,3.25c0,.18-.13.43-.2.71a5.57,5.57,0,0,1-3.28.55c-.06,0-.09.13,0,.14A5.37,5.37,0,0,0,35.58,94c-.29,1.25-.46,2.9.71,3.22s2.56-1.13,3.18-2a13.28,13.28,0,0,0,1.25-2,.83.83,0,0,1,.11-.15c0,.58.11,1,.68.9s1.09-.91,1.41-1.35.57-.85.85-1.28c0,.52.14,1.11.64,1s.91-1,1.14-1.31.4-.62.57-.94a.62.62,0,0,0,.11.17c.41.45.9,0,1.17-.38.38-.5.81-1,1.16-1.58a1,1,0,0,0,.5.55c.63.3,1.23-.23,1.6-.7a14,14,0,0,0,1.2-1.92.92.92,0,0,0,.44.61,1.47,1.47,0,0,0,1.5-.1C54,86.63,53.8,86.2,53.59,86.31Zm-14,2.49c.3-.15.91-.41.94.09a1.69,1.69,0,0,1-.4.88,11.16,11.16,0,0,1-1.73,1.84,13.59,13.59,0,0,1-2.18,1.65A7,7,0,0,1,39.64,88.8Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "43.1279px 91.16px 0px",
          }}
          id="elqo0ok09veln"
          className="animable"
        />
      </g>
      <g
        id="freepik--picture--inject-64"
        style={{
          transformOrigin: "45.935px 146.895px 0px",
        }}
        className="animable"
      >
        <polygon
          points="22.3 135.19 24.19 136.28 24.19 184.8 22.3 183.71 22.3 135.19"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "23.245px 159.995px 0px",
          }}
          id="eli69p48b3pi"
          className="animable"
        />
        <polygon
          points="25.85 177.58 27.72 178.69 66.05 156.56 64.18 155.45 25.85 177.58"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "45.95px 167.07px 0px",
          }}
          id="elf9t2jto7wos"
          className="animable"
        />
        <path
          d="M69.57,110.08l-45.38,26.2V184.8l45.38-26.2Zm-3.52,46.48L27.72,178.69V138.31l38.33-22.13Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "46.88px 147.44px 0px",
          }}
          id="el6vidqs3xkdl"
          className="animable"
        />
        <polygon
          points="66.05 156.56 64.18 155.45 64.18 117.28 66.05 116.18 66.05 156.56"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "65.115px 136.37px 0px",
          }}
          id="el3vmbi5jmvfm"
          className="animable"
        />
        <polygon
          points="69.57 110.08 67.68 108.99 22.3 135.19 24.19 136.28 69.57 110.08"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "45.935px 122.635px 0px",
          }}
          id="eloj2t0avmco"
          className="animable"
        />
        <path
          d="M48.84,142.94h0l-.06,0s0,0,0,0h.05S48.84,142.93,48.84,142.94Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "48.81px 142.938px 0px",
          }}
          id="elhal6yx8aj4"
          className="animable"
        />
        <polygon
          points="64.18 155.45 27.72 176.5 27.72 138.31 64.18 117.28 64.18 155.45"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "45.95px 146.89px 0px",
          }}
          id="elq2vak3eikcd"
          className="animable"
        />
        <path
          d="M59,147.37c1.66-1,3-.18,3,1.73a6.67,6.67,0,0,1-3,5.22c-1.66,1-3,.18-3-1.74A6.65,6.65,0,0,1,59,147.37Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "59px 150.845px 0px",
          }}
          id="el1t811oofqmv"
          className="animable"
        />
        <path
          d="M34.63,139.53l22.66-13.09c.63-.37,1.14-.07,1.14.66v.06a2.53,2.53,0,0,1-1.14,2l-22.66,13.1c-.63.37-1.14.07-1.14-.66v-.07A2.52,2.52,0,0,1,34.63,139.53Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "45.96px 134.35px 0px",
          }}
          id="ela0he9mhy59r"
          className="animable"
        />
        <path
          d="M31,149.84l29.83-17.22c.63-.36,1.14-.2,1.14.37a2.28,2.28,0,0,1-1.14,1.69L31,151.91c-.63.37-1.14.2-1.13-.37A2.33,2.33,0,0,1,31,149.84Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "45.9199px 142.267px 0px",
          }}
          id="elt1y3hlbdw99"
          className="animable"
        />
        <path
          d="M31,154l29.83-17.21c.63-.37,1.14-.2,1.14.37a2.29,2.29,0,0,1-1.14,1.69L31,156c-.63.36-1.14.19-1.13-.38A2.35,2.35,0,0,1,31,154Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "45.9199px 146.391px 0px",
          }}
          id="el8f73aw41ls4"
          className="animable"
        />
        <path
          d="M31,158.07l29.83-17.22c.63-.37,1.14-.2,1.14.37a2.29,2.29,0,0,1-1.14,1.69L31,160.14c-.63.36-1.14.19-1.13-.38A2.32,2.32,0,0,1,31,158.07Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "45.9199px 150.491px 0px",
          }}
          id="elfiltmvmvlo6"
          className="animable"
        />
        <path
          d="M53.59,156.17a1.7,1.7,0,0,1-.74.2c-.64,0-.58-.65-.56-1.1,0-.2-.27-.51-.42-.25-.38.7-.88,1.35-1.29,2-.26.41-.74,1.35-1.35,1.22-.26-.06-.34-.33-.34-.67a3.34,3.34,0,0,0,.4-1.86c0-.19-.35-.43-.46-.17a6,6,0,0,0-.38,1.71,10.65,10.65,0,0,1-1,1.44c-.2.27-.39.58-.61.84-.06.06-.16.22-.25.23s-.19-.09-.22-.23a1.45,1.45,0,0,1,.1-.61h0l0,0h0c0-.2-.26-.5-.37-.25a8.85,8.85,0,0,1-1.75,2.92,1,1,0,0,1-.11.1c0-.12,0-.24-.05-.36a2.75,2.75,0,0,0-.14-.81c-.05-.13-.28-.33-.4-.16a13.83,13.83,0,0,1-2,2.75,3,3,0,0,1-.42.28c-.13-.07.08-.79.1-.9a9.75,9.75,0,0,1,.3-1,4,4,0,0,0,.24-.79c0-.25-.39-.62-.46-.29l-.28.86a20,20,0,0,1-1.67,2.83,6.44,6.44,0,0,1-2.33,2.25c-.27.14-.76.35-1,.14s-.26-.58-.27-.84a6.93,6.93,0,0,1,.27-2.07,12.37,12.37,0,0,0,2.59-1.82,8.76,8.76,0,0,0,2-2.17c.27-.48.43-1.27-.21-1.54-.45-.19-1,.13-1.4.34a6.07,6.07,0,0,0-1.42,1.1,8.29,8.29,0,0,0-1.78,3.25c0,.19-.13.43-.2.71a5.49,5.49,0,0,1-3.28.55c-.06,0-.09.13,0,.14a5.37,5.37,0,0,0,3.22-.3c-.29,1.25-.46,2.89.71,3.21s2.56-1.13,3.18-2a13.38,13.38,0,0,0,1.25-2,.76.76,0,0,1,.11-.14c0,.57.11,1,.68.9s1.09-.91,1.41-1.35.57-.85.85-1.29c0,.52.14,1.12.64,1s.91-1,1.14-1.32.4-.61.57-.93a.62.62,0,0,0,.11.17c.41.44.9,0,1.17-.38s.81-1,1.16-1.59a1,1,0,0,0,.5.56c.63.3,1.23-.23,1.6-.7a13.56,13.56,0,0,0,1.2-1.93.88.88,0,0,0,.44.61,1.47,1.47,0,0,0,1.5-.1C54,156.49,53.8,156.07,53.59,156.17Zm-14,2.49c.3-.15.91-.4.94.1a1.62,1.62,0,0,1-.4.87,11.23,11.23,0,0,1-1.73,1.85,14.87,14.87,0,0,1-2.18,1.65A7,7,0,0,1,39.64,158.66Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "43.1422px 161.008px 0px",
          }}
          id="elrrucr6sx0c"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Desk--inject-64"
      style={{
        transformOrigin: "118.965px 277.391px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--desk--inject-64"
        style={{
          transformOrigin: "118.965px 277.391px 0px",
        }}
        className="animable"
      >
        <path
          d="M56.55,384.68h11l-1.75,10.7h0a2,2,0,0,1-1.06,1.32,5.85,5.85,0,0,1-5.31,0,2,2,0,0,1-1.06-1.32h0Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "62.05px 391.009px 0px",
          }}
          id="elr1eqouygkzc"
          className="animable"
        />
        <g id="el740tao5u9cs">
          <path
            d="M56.55,384.68h11l-1.75,10.7h0a2,2,0,0,1-1.06,1.32,5.85,5.85,0,0,1-5.31,0,2,2,0,0,1-1.06-1.32h0Z"
            style={{
              opacity: 0.1,
              transformOrigin: "62.05px 391.009px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M199.73,302.11h11L209,312.8h0a1.92,1.92,0,0,1-1.06,1.32,5.85,5.85,0,0,1-5.31,0,1.92,1.92,0,0,1-1.06-1.32h0Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "205.23px 308.434px 0px",
          }}
          id="elnny4cfbojyd"
          className="animable"
        />
        <g id="elwlg2u1ik1tc">
          <path
            d="M199.73,302.11h11L209,312.8h0a1.92,1.92,0,0,1-1.06,1.32,5.85,5.85,0,0,1-5.31,0,1.92,1.92,0,0,1-1.06-1.32h0Z"
            style={{
              opacity: 0.1,
              transformOrigin: "205.23px 308.434px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M24.5,366.15h11l-1.75,10.7h0a2,2,0,0,1-1.07,1.32,5.83,5.83,0,0,1-5.3,0,2,2,0,0,1-1.06-1.32h0Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "30px 372.479px 0px",
          }}
          id="elx0wl04hhty"
          className="animable"
        />
        <g id="elvs77mxe9iqd">
          <path
            d="M24.5,366.15h11l-1.75,10.7h0a2,2,0,0,1-1.07,1.32,5.83,5.83,0,0,1-5.3,0,2,2,0,0,1-1.06-1.32h0Z"
            style={{
              opacity: 0.1,
              transformOrigin: "30px 372.479px 0px",
            }}
            className="animable"
          />
        </g>
        <polygon
          points="21.79 250.24 21.79 370.88 62.1 394.18 62.1 273.53 21.79 250.24"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "41.945px 322.21px 0px",
          }}
          id="el9j7ld4md965"
          className="animable"
        />
        <polygon
          points="62.1 394.18 217.31 304.66 217.31 184.01 62.1 273.53 62.1 394.18"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "139.705px 289.095px 0px",
          }}
          id="elreuasttu1t"
          className="animable"
        />
        <polygon
          points="106.63 368.5 108.79 367.25 108.79 246.6 106.63 247.84 106.63 368.5"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "107.71px 307.55px 0px",
          }}
          id="el2k7vdp3vbt"
          className="animable"
        />
        <polygon
          points="180.16 326.04 182.32 324.8 182.32 204.15 180.16 205.39 180.16 326.04"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "181.24px 265.095px 0px",
          }}
          id="elnqhqwujwe2"
          className="animable"
        />
        <path
          d="M223,184.74a1.62,1.62,0,0,0-1-1.34L178.15,158a5.13,5.13,0,0,0-4.64,0L15.87,248.9a1.62,1.62,0,0,0-1,1.34v3.07a1.64,1.64,0,0,0,1,1.34L59.79,280a5.17,5.17,0,0,0,4.63,0L222.06,189.1a1.62,1.62,0,0,0,1-1.33Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "118.965px 218.996px 0px",
          }}
          id="elmna93ocdigb"
          className="animable"
        />
        <path
          d="M14.91,250.24v3.07a1.64,1.64,0,0,0,1,1.34L59.79,280a4.81,4.81,0,0,0,2.31.55l31-48.63L68.48,218.54,15.87,248.9A1.62,1.62,0,0,0,14.91,250.24Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "54.005px 249.545px 0px",
          }}
          id="elutlsm029w1r"
          className="animable"
        />
        <path
          d="M173.51,158,15.87,248.9c-1.28.74-1.28,1.93,0,2.67L59.79,277a5.11,5.11,0,0,0,4.63,0l157.64-90.89c1.28-.74,1.28-1.93,0-2.67L178.15,158A5.13,5.13,0,0,0,173.51,158Z"
          style={{
            fill: "rgb(245, 245, 245)",
            transformOrigin: "118.965px 217.5px 0px",
          }}
          id="el3gv0zfna3vg"
          className="animable"
        />
        <path
          d="M78.53,282c0,.75,2.23.06,5-1.52l6.55-3.77c2.75-1.59,5-3.49,5-4.23v-1.35l-16.5,9.53Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "86.805px 276.717px 0px",
          }}
          id="el3a1t028noro"
          className="animable"
        />
        <path
          d="M190.73,217.32c0,.74,2.23.06,5-1.52l6.55-3.78c2.75-1.58,5-3.48,5-4.23v-1.34L190.73,216Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "199.005px 212.035px 0px",
          }}
          id="eluhcwvdg1l4k"
          className="animable"
        />
        <path
          d="M135.42,259.12c0,.74,2.23.06,5-1.53l6.56-3.77c2.74-1.59,5-3.49,5-4.23v-1.35l-16.5,9.53Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "143.7px 253.829px 0px",
          }}
          id="elyrpua64nh5"
          className="animable"
        />
        <path
          d="M135.42,287.69c0,.75,2.23.07,5-1.52L147,282.4c2.74-1.59,5-3.49,5-4.23v-1.35l-16.5,9.53Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "143.71px 282.408px 0px",
          }}
          id="elw8zppep28bn"
          className="animable"
        />
        <path
          d="M135.42,328.73c0,.75,2.23.06,5-1.52l6.56-3.77c2.74-1.59,5-3.49,5-4.23v-1.35l-16.5,9.53Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "143.7px 323.447px 0px",
          }}
          id="el08fy344ulpej"
          className="animable"
        />
        <polygon
          points="181.24 250.37 107.37 293.02 107.37 295.4 181.24 252.75 181.24 250.37"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "144.305px 272.885px 0px",
          }}
          id="eluzys62hihw"
          className="animable"
        />
        <polygon
          points="181.24 291.41 107.37 334.06 107.37 336.44 181.24 293.79 181.24 291.41"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "144.305px 313.925px 0px",
          }}
          id="elkqlx9pyrki"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Heart--inject-64"
      style={{
        transformOrigin: "183.017px 258.342px 0px",
      }}
      className="animable animator-active"
    >
      <g
        id="freepik--heart--inject-64"
        style={{
          transformOrigin: "183.017px 258.342px 0px",
        }}
        className="animable"
      >
        <path
          d="M148.4,134c-1.19-7.92-8.86-14.12-17.45-14.12a15.87,15.87,0,0,0-5.58,1l-2.89-15.29s-4.32-3.82-16.54-.76-13.48,7.29-13.48,7.29l11.45,66.5-24.5,2.28c-7.9,6.24-2.7,22,.58,23.42l29.17-2,4.16,21.12,29.93-6.49-7.82-55.84c3.43-4.33,11.74-17.16,11.66-19.11A12.76,12.76,0,0,0,148.4,134Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "111.909px 163.541px 0px",
          }}
          id="el6gizcio9nf3"
          className="animable"
        />
        <g id="elbz6vannrw84">
          <path
            d="M148.4,134c-1.19-7.92-8.86-14.12-17.45-14.12a15.87,15.87,0,0,0-5.58,1l-2.89-15.29s-4.32-3.82-16.54-.76-13.48,7.29-13.48,7.29l11.45,66.5-24.5,2.28c-7.9,6.24-2.7,22,.58,23.42l29.17-2,4.16,21.12,29.93-6.49-7.82-55.84c3.43-4.33,11.74-17.16,11.66-19.11A12.76,12.76,0,0,0,148.4,134Z"
            style={{
              opacity: 0.15,
              transformOrigin: "111.909px 163.541px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elfjcfp7ltcv4">
          <path
            d="M146.82,142.8c-.66,1.48-2.9,4.59-10.27,5.92-9.85,1.79-16.41-6.54-16.41-6.54s-.83,3-5.38,9.87-7,6.07-8,3.79-1.89-9.09-4.92-25.58-2.09-21.4,4.89-25.6c-.28.07-.53.11-.82.19-12.21,3.05-13.48,7.29-13.48,7.29l11.45,66.5a44.33,44.33,0,0,1,7.9.39,18.72,18.72,0,0,1,7.48,3.08c2.25,1.56,4.57,3.56,4.48,6.32-.19,6.07-12.82,8.64-25.77,9.71s-19.4,1.82-22-1c1,3.7,2.61,6.64,3.94,7.23l29.17-2,4.16,21.12,29.93-6.49-7.82-55.84c2.88-3.63,9.18-13.24,11.1-17.4Z"
            style={{
              opacity: 0.1,
              transformOrigin: "111.395px 164.075px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M134.4,149.08c-8.59,0-16.25-6.21-17.45-14.12a12.66,12.66,0,0,1,2.88-10.27,14.55,14.55,0,0,1,11.12-4.8c8.59,0,16.26,6.2,17.45,14.12a12.6,12.6,0,0,1-2.88,10.26A14.52,14.52,0,0,1,134.4,149.08Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "132.676px 134.485px 0px",
          }}
          id="el5vqh3oya1va"
          className="animable"
        />
        <g id="elnrjq2uxjl9">
          <ellipse
            cx={132.68}
            cy={134.48}
            rx={10.99}
            ry={13.07}
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "132.68px 134.48px 0px",
              transform: "rotate(-64.09deg)",
            }}
            className="animable"
          />
        </g>
        <g id="elhh6pd5ju0e">
          <ellipse
            cx={132.68}
            cy={134.48}
            rx={10.99}
            ry={13.07}
            style={{
              opacity: 0.3,
              transformOrigin: "132.68px 134.48px 0px",
              transform: "rotate(-64.09deg)",
            }}
            className="animable"
          />
        </g>
        <g id="elbwfe7lf4i1n">
          <path
            d="M140.59,144.28a.76.76,0,0,0,0-.15c-1-6.31-7.36-11.42-14.31-11.42a12,12,0,0,0-6.19,1.62.76.76,0,0,0,0,.15c1,6.31,7.36,11.42,14.31,11.42A12,12,0,0,0,140.59,144.28Z"
            style={{
              opacity: 0.3,
              transformOrigin: "130.34px 139.305px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M107.29,148.72a72.8,72.8,0,0,0,5.94-9.93,75.1,75.1,0,0,0,4.49-10.66c-2,3.32-3.76,6.73-5.51,10.15S108.79,145.15,107.29,148.72Zm20.6,20.71c-2.4,2.86-4.78,5.74-7,8.8a71.29,71.29,0,0,0,7.86-8.07,75.31,75.31,0,0,0,6.67-9.07C132.76,163.76,130.32,166.58,127.89,169.43Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "121.355px 153.18px 0px",
          }}
          id="elo0dh1jn19tj"
          className="animable"
        />
        <g id="elz976s4hvsef">
          <path
            d="M107.29,148.72a72.8,72.8,0,0,0,5.94-9.93,75.1,75.1,0,0,0,4.49-10.66c-2,3.32-3.76,6.73-5.51,10.15S108.79,145.15,107.29,148.72Zm20.6,20.71c-2.4,2.86-4.78,5.74-7,8.8a71.29,71.29,0,0,0,7.86-8.07,75.31,75.31,0,0,0,6.67-9.07C132.76,163.76,130.32,166.58,127.89,169.43Z"
            style={{
              opacity: 0.5,
              transformOrigin: "121.355px 153.18px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eli8pb4hpkv4f">
          <g
            style={{
              opacity: 0.1,
              transformOrigin: "146.955px 142.39px 0px",
            }}
            className="animable"
          >
            <path
              d="M146.82,142.8a3.12,3.12,0,0,0,.27-.82Z"
              id="elqd514497uo"
              style={{
                transformOrigin: "146.955px 142.39px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M138.81,177.16A96,96,0,0,1,160.48,136c9.38-10.27,13.09-11.18,12.8-13.93s-3.71-27.94-3.71-27.94,2-2.59,8.56-3.56,8.56,1,8.56,1l4.21,29.91a1,1,0,0,0,.54.75h0a1,1,0,0,0,1.43-.91l-.19-8s1.14-1.89,6.56-2.35,7.42,3.32,7.42,3.32l1.43,17.22s9.53,9.48,12,22.35v86.37H133.24S130.88,208.66,138.81,177.16Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "176.501px 165.266px 0px",
          }}
          id="el8vhfyamy0de"
          className="animable"
        />
        <g id="eldfg4m6kz66k">
          <path
            d="M138.81,177.16A96,96,0,0,1,160.48,136c9.38-10.27,13.09-11.18,12.8-13.93s-3.71-27.94-3.71-27.94,2-2.59,8.56-3.56,8.56,1,8.56,1l4.21,29.91a1,1,0,0,0,.54.75h0a1,1,0,0,0,1.43-.91l-.19-8s1.14-1.89,6.56-2.35,7.42,3.32,7.42,3.32l1.43,17.22s9.53,9.48,12,22.35v86.37H133.24S130.88,208.66,138.81,177.16Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.1,
              transformOrigin: "176.501px 165.266px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eluxhcusaar2g">
          <path
            d="M167.13,191.23c-6.49,13.84-14.3,9.2-18.58,4.26-7.8-9,2.89-46.41,14.2-60.79l.07-1.18c-.74.77-1.51,1.58-2.34,2.49a96,96,0,0,0-21.67,41.15c-7.93,31.5-5.57,63.06-5.57,63.06h86.83V153.85C189.55,145.87,173.62,177.39,167.13,191.23Z"
            style={{
              opacity: 0.1,
              transformOrigin: "176.491px 186.87px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el8c4a3il68wi">
          <path
            d="M169.26,200.21s-9.36,20.13-20.71,11.21-11-23.77-8.12-40q-.92,2.9-1.62,5.71c-7.93,31.5-5.57,63.06-5.57,63.06h36Z"
            style={{
              opacity: 0.1,
              transformOrigin: "151.086px 205.805px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elmqk97no4ror">
          <path
            d="M178.13,90.58c-6.56,1-8.56,3.56-8.56,3.56s3.43,25.18,3.71,27.94c.14,1.33-.67,2.24-2.58,4,4.51-3.9,7.26-4.14,6.81-7.45-.48-3.53-1.45-9.62-2.41-16.37S173.9,91.59,178.13,90.58Z"
            style={{
              opacity: 0.1,
              transformOrigin: "173.85px 108.33px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eldregw8iq5ze">
          <path
            d="M193.46,123.28c1.88.83,3,1.38,4.19,2s-1.05-2.43-1.1-6.29c0-2.29-.07-5.41-.09-7.59-3,.72-3.78,1.92-3.78,1.92l.19,8a1,1,0,0,1-2,.16C191.09,122.82,191.58,122.45,193.46,123.28Z"
            style={{
              opacity: 0.1,
              transformOrigin: "194.434px 118.38px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M272,157.47c-8.73,2.18-26.5.55-37.49-2s-34.26-5.16-50.1,18.76-22.62,42-30.7,60.11-33.93,46-44.6,66.29-13.25,53.29,18.1,77.85S187,411.74,198,415.94s44.92,18.1,64,4.85,40.72-41,36.52-95-26.62-72.16-33-79.07c-12.28-13.36-40.72-24.35-40.72-37.28s8.41-19.71,18.75-19.06,17.74-.13,24.52-1.75c3.28-1.89,6.73-5.68,8.51-12.24C278.87,168.07,277.19,156.83,272,157.47Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "200.446px 290.128px 0px",
          }}
          id="el9vn54xrm0cg"
          className="animable"
        />
        <g id="elnp92y99nc8i">
          <path
            d="M272,157.47c-8.73,2.18-26.5.55-37.49-2s-34.26-5.16-50.1,18.76-22.62,42-30.7,60.11-33.93,46-44.6,66.29-13.25,53.29,18.1,77.85S187,411.74,198,415.94s44.92,18.1,64,4.85,40.72-41,36.52-95-26.62-72.16-33-79.07c-12.28-13.36-40.72-24.35-40.72-37.28s8.41-19.71,18.75-19.06,17.74-.13,24.52-1.75c3.28-1.89,6.73-5.68,8.51-12.24C278.87,168.07,277.19,156.83,272,157.47Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.25,
              transformOrigin: "200.446px 290.128px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M292,330.89c-2.11-2.53-2.9-5.87-4.76-8.58-2.19-3.19-5.76-3.55-9-5.05-3.07-1.4-5.48-3.94-8.21-5.86a15.9,15.9,0,0,0-9.83-3.08c-2.16,0-4.71.43-6.68-.62a15,15,0,0,1-4.71-4.73c-1.91-2.77-4.07-6.19-4.48-9.55q-.76-6.27-1.13-12.57c-.1-1.86-1-7.77,2.06-7.71,2.54,0,3.66,3.62,4.49,5.45,1,2.25,2.11,4.45,4.23,5.84s5.34,2.27,5.82,5.24c0,.15.14,0,.13-.09-.24-2.26-2.09-3.63-3.89-4.75a12.48,12.48,0,0,1-3.26-2.56,13.1,13.1,0,0,1-1.82-3.45,25.08,25.08,0,0,0-3-6.14c-1.46-2-3.32-5.51-2.62-8.05.83-3,1.85-5.49,1.61-8.74-.16-2-3.73-2.23-4.87-1.16-2.1,2-2.82,5-4,7.58-2,4.32-4.88,8.17-9.81,5.33-2.3-1.33-4.29-3.13-6.83-4a13.74,13.74,0,0,0-7.39-.1c-3.1.64-6.71,1.23-9.27-1.1-.08-.07-.14.16-.09.22,4.12,5.38,12.1.57,17.26,3.59a12.93,12.93,0,0,1,4.87,5.26c1.7,3.56-1.7,6.27-3.79,8.82a7,7,0,0,1-3.74,2.38c-2.82.72-5.8.27-8.63.92a8.15,8.15,0,0,0-3.46,1.67,9.64,9.64,0,0,0-2.23,3.29,9.21,9.21,0,0,1-7.85,5.18c-.15,0-.18.34,0,.34a8.89,8.89,0,0,0,7.38-3.57c.94-1.27,1.6-2.75,2.84-3.78a8.36,8.36,0,0,1,4.55-1.56,11.26,11.26,0,0,1,7.54,1.4c2.44,1.64,1.93,5.26,1.11,7.63a29.93,29.93,0,0,0-1.73,5.39c-.37,2.54.54,5.05.3,7.57-.19,2-.65,4-.85,6a10.07,10.07,0,0,1-3.2,6.93c-1.48,1.23-3.92,2-4.14,4.17,0,.11.1.14.12,0,.31-2.26,3.49-2.95,5-4.4,2.31-2.29,2.66-5,3.34-7.93.53-2.32,1.62-4.53,1.51-6.9a15.67,15.67,0,0,1,1-7.28c.91-1.95,2.48-3.56,3.23-5.57.84-2.24.61-4.67,1-7a20.34,20.34,0,0,1,1.85-5.44c1.26-2.55,4.54-7.47,8-6.54,2.15.57,2.09,3.27,2.18,5,.16,3.2.47,6.38.47,9.59a28,28,0,0,1-2.91,12.46,19.52,19.52,0,0,0-1.85,8.53c0,2.91.06,5.49-1.36,8.12a35.42,35.42,0,0,1-3.95,5.42c-3.07,3.73-5.61,7.37-5.27,12.42.19,2.91.87,5.82-1,8.35-1.49,2-3.57,3.39-5,5.42-2.82,4-3.63,9-4.63,13.64a47,47,0,0,1-1.66,6.71,21.76,21.76,0,0,1-4.15,6.73c-1.74,2-3.66,4-4.76,6.43a9.75,9.75,0,0,0-.87,3.75c-.05,1.7.29,3.43-.19,5.09-1.29,4.41-6.87,7.23-6.3,12.25,0,.13.13,0,.12-.08-.36-4.58,4.75-7.16,6.45-10.95,1.16-2.59.19-5.43,1.08-8.06.81-2.4,2.71-4.26,4.46-6a27.76,27.76,0,0,0,4.65-5.61,30.6,30.6,0,0,0,2.57-6.24c1.47-4.76,2.24-10,4.65-14.4,1.26-2.31,3.1-3.89,4.9-5.75a9.32,9.32,0,0,0,2.86-6.83c0-2.77-.76-5.49.11-8.2a18.1,18.1,0,0,1,3.33-5.58c2.88-3.61,6.14-7,6.85-11.74.41-2.84-.57-13,4.66-12.45,2,.19,3,2.07,3.91,3.56,1.29,2.06,2.75,4,3.87,6.17,1.42,2.75,1.88,5.81,2.68,8.76a25.09,25.09,0,0,0,2.69,6.17c0,.13.05.26.07.39a18.75,18.75,0,0,1,.16,4.49,61,61,0,0,1-1.73,8c-.55,2.46-.24,4.89-.27,7.38a17.11,17.11,0,0,1-1.75,8.16c0,.05,0,.23.07.13a12.5,12.5,0,0,0,2-6.55,35.86,35.86,0,0,1,1.31-7.7c.49-1.47,1.37-2.72,2-4.13s.5-2.36,2.25-1.95a3.56,3.56,0,0,1,1.91,1.32c1.33,1.6,1.77,4,2.1,6,.68,4.07.52,8.17.67,12.28.19,5.13,1.2,10.85,5.42,14.26.1.08.16-.18.09-.25-4.23-3.74-4.92-9.65-4.63-15,.12-2.3-.77-6.8,2.38-6.59a14.42,14.42,0,0,1,5,1.77,12.33,12.33,0,0,1,1.79,1.05A6.1,6.1,0,0,1,275,350.6s.09-.05.05-.09c-.55-.45-1-1.1-1.5-1.59s-.77-.67-1.17-1c-1.16-.91-2.29-1.86-3.44-2.78a14.89,14.89,0,0,1-3.21-3.13,29.81,29.81,0,0,1-2-4.09,21.55,21.55,0,0,0-1.16-3.1c-1.54-3.29-3.71-6.26-5.43-9.45,0-.13,0-.25-.08-.38a2.49,2.49,0,0,0-.85-1.47,22.37,22.37,0,0,1-1.18-3.11c-.85-3-1.2-6.1-2.39-9-.16-.38-.34-.73-.51-1.1a9.52,9.52,0,0,0,2.15.65c3.93.71,8.07-1,11.87.66,3.24,1.4,5.76,4.11,7.95,6.81,1.78,2.19,2.22,4.85,3.48,7.31.9,1.77,2.09,3.4,2.91,5.21a13.45,13.45,0,0,1,1.28,6.36c0,.22.23.35.29.08a10.64,10.64,0,0,0-.62-5.52,55.09,55.09,0,0,0-2.35-5.54c-.8-1.69-1.84-4-.81-5.85,1.13-2,4.8.16,6.27.81,2.56,1.12,3.51,2.89,4.63,5.28a19,19,0,0,0,2.67,4.54C292,331.28,292.08,331,292,330.89Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "243.355px 328.647px 0px",
          }}
          id="els33skdy4orf"
          className="animable"
        />
        <path
          d="M189.34,331.31c-2.83-1.95-6.65-2.91-8.84-5.68-1.05-1.32-1.57-2.93-2.92-4s-3.06-1.62-4.39-2.81a11.57,11.57,0,0,1-3-4.29,14.08,14.08,0,0,1-.46-9.36,2,2,0,0,1,.64-1c1.05-.73,4.09,2,5.11,2.45a19.39,19.39,0,0,0,7,1.35,13.13,13.13,0,0,1,4.78.81,8,8,0,0,1,2.46,2c.19.19.31-.25.25-.37-.88-2-3.22-3-5.15-3.65-2.67-.84-5.57-.65-8.2-1.67a26,26,0,0,1-9.66-7.38,2.47,2.47,0,0,1-.67-1.68c.09-1.13,1.29-1.32,2.15-1.52a21.44,21.44,0,0,0,3.41-1.08c2.14-.87,4.52-1.75,6.86-1.32.06,0,.09-.13,0-.14a15.7,15.7,0,0,0-6.82.13c-5.8,1-11.22,1.32-17,0a24.77,24.77,0,0,1-6.8-2.38,13.29,13.29,0,0,1-4.83-4.82c-1.31-2.13-1.3-5-1.86-7.44a17.9,17.9,0,0,0-1.34-3.89,4.85,4.85,0,0,0-3.56-3,.49.49,0,0,0-.56.33c-.45,1.55.62,2.36,1.23,3.67a16.53,16.53,0,0,1,1.07,3.64c.62,3.08,1.41,6.81,1,9.95a18,18,0,0,1-1.78,5c-.6,1.26-1.2,2.41-1.92,3.61-.52.87-1,1.77-1.47,2.68a7,7,0,0,0-1.67,2.05,20.62,20.62,0,0,0-1.7,3.22,16.81,16.81,0,0,0-1.07,3.45c-.37,1.95-.55,3.69-1.8,5.26-1.5,1.9-3.14,3.51-4.17,5.73a13.61,13.61,0,0,0-1.27,6.83c0,.22.24.16.25,0a13,13,0,0,1,2.29-7.36,23.41,23.41,0,0,1,2.93-3,11.25,11.25,0,0,0,1.39-1.37c.63-.87,1-2.49,2.27-1,.7.83.53,2.27.4,3.28-.27,2.19-1.13,4.26-1.41,6.45-.64,4.83,2.27,9.21,2,14-.21,4.45-4.3,9.58-1.17,13.79.13.17.25-.22.16-.35-2.95-4.25,1.61-8.83,2.09-13.08.54-4.73-1.73-9.36-.72-14.06.47-2.2,1.39-4.28,1.63-6.53.26-2.43-.36-4.81-.32-7.23,0-1.81,2.8-14.11,6-11.74.89.65.91,2.27,1.26,3.24,1.48,4,5,6.83,7.79,9.91.07.08.13-.1.09-.16-1.31-1.73-2.56-3.53-3.86-5.27a13.56,13.56,0,0,1-2.69-5.29c-.39-1.77-1.32-5.44-.24-7.08a2.22,2.22,0,0,1,1.54-1,4.17,4.17,0,0,1,1.22.09,12.79,12.79,0,0,1,2.38,1,25,25,0,0,0,3.27,1c4.55,1,10.69.93,13.49,5.31s2.42,9.84,2.5,14.59c.06,3.53-.31,7.09,0,10.61a22.55,22.55,0,0,0,3.16,9.26c1.69,3,3.59,5.92,4.33,9.33.05.25.3,0,.26-.16-.72-3.89-3-7.22-4.74-10.7a16,16,0,0,1-1.37-12,4.49,4.49,0,0,1,.54-1.34.48.48,0,0,1,.2-.2.43.43,0,0,1,.33.05,5.1,5.1,0,0,1,1.77,1.2,12.27,12.27,0,0,0,2.35,1.51c.79.5,1.73.82,2.48,1.38a8.22,8.22,0,0,1,1.85,2.51c1.84,3,4.91,4.47,8,5.64a19.46,19.46,0,0,1,5.15,2.32,7.68,7.68,0,0,1,3.22,4.82c.06.39.41.15.36-.15C194.4,334.91,191.87,333.06,189.34,331.31Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "158.589px 310.692px 0px",
          }}
          id="elzeia99d3u68"
          className="animable"
        />
        <g id="el80hrqoddk7r">
          <path
            d="M184.44,174.2c-15.83,23.91-22.62,42-30.7,60.11s-33.93,46-44.6,66.29-13.25,53.29,18.1,77.85S187,411.74,198,415.94s44.92,18.1,64,4.85c11.25-7.82,23.4-20.71,30.61-41.05-8,20.3-28.5,32.79-47.64,33.41-19.94.64-61.7-12.5-99.42-64.06-28.63-39.12-5-50.81,12.13-101.89C164.41,227.17,167.13,208.22,184.44,174.2Z"
            style={{
              fill: "rgb(186, 104, 200)",
              opacity: 0.4,
              transformOrigin: "197.241px 300.292px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elbknhwft70qu">
          <path
            d="M184.44,174.2c-15.83,23.91-22.62,42-30.7,60.11s-33.93,46-44.6,66.29-13.25,53.29,18.1,77.85S187,411.74,198,415.94s44.92,18.1,64,4.85c11.25-7.82,23.4-20.71,30.61-41.05-8,20.3-28.5,32.79-47.64,33.41-19.94.64-61.7-12.5-99.42-64.06-28.63-39.12-5-50.81,12.13-101.89C164.41,227.17,167.13,208.22,184.44,174.2Z"
            style={{
              opacity: 0.05,
              transformOrigin: "197.241px 300.292px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elrt6k4eebfy">
          <path
            d="M270.12,251.42c-1.88-2-3.46-3.53-4.56-4.72-12.28-13.36-40.72-24.35-40.72-37.28a26.72,26.72,0,0,1,.43-4.78l-.29-.06c-2.78,8.52-1.78,16.45,1.78,27.56s4,30.73,16.47,35.48C255.52,272.31,268.42,260.71,270.12,251.42Z"
            style={{
              opacity: 0.1,
              transformOrigin: "246.75px 236.638px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M153.23,235.19c0-12-10.08-20.47-23.39-25.53s-20.68-7.36-20.68-7.36l-13.92,1s-5.71,7.14-12.1,16.73-16.91,29.32-18,54.61,9.54,55.9,36.71,56.16c2.42-13.57,9.07-23.15,21.58-37.26S153.23,255.14,153.23,235.19Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "109.147px 266.55px 0px",
          }}
          id="elseoiy1kugql"
          className="animable"
        />
        <g id="elb8muenh9jrj">
          <path
            d="M130,277c-10.85,9.75-24.17,12-35-.27s-12.89-33.69-3-54c9.5-19.54,16.69-20.44,17.2-20.48l-13.89,1s-5.71,7.14-12.1,16.73-16.91,29.32-18,54.61,9.54,55.9,36.71,56.16c2.42-13.57,9.07-23.15,21.58-37.26,10.09-11.38,23.26-29.35,28-46.34C148.35,255.84,139.05,268.87,130,277Z"
            style={{
              opacity: 0.1,
              transformOrigin: "108.317px 266.5px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M227.52,198.38s-5.12,4.9-2.9,17.24c1.75,9.73,6.2,20.42,8.65,30.18,4.18,16.65,9.29,21.69,19.63,18.75s16.82-9.74,19.2-18.54c2.74-10.17,1.69-14.16,9.28-16.25,7.81-2.14,19.21-5.33,19.21-5.33s2.35-10.92-4.65-15.56l-22.36,4.43,19.26-10.84a12.81,12.81,0,0,0-2.36-12.58c-5.06-6.12-7.83-5.07-7.83-5.07s-24.9,13.93-28.91,15.83-6,3.48-14.56.42A56.71,56.71,0,0,0,227.52,198.38Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "262.516px 225.041px 0px",
          }}
          id="eltda2mkizie"
          className="animable"
        />
        <g id="elqbcq0u5jvr">
          <path
            d="M227.52,198.38s-5.12,4.9-2.9,17.24c1.75,9.73,6.2,20.42,8.65,30.18,4.18,16.65,9.29,21.69,19.63,18.75s16.82-9.74,19.2-18.54c2.74-10.17,1.69-14.16,9.28-16.25,7.81-2.14,19.21-5.33,19.21-5.33s2.35-10.92-4.65-15.56l-22.36,4.43,19.26-10.84a12.81,12.81,0,0,0-2.36-12.58c-5.06-6.12-7.83-5.07-7.83-5.07s-24.9,13.93-28.91,15.83-6,3.48-14.56.42A56.71,56.71,0,0,0,227.52,198.38Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.1,
              transformOrigin: "262.516px 225.041px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elicggdtfdjko">
          <path
            d="M272.1,246c2.74-10.17,1.69-14.16,9.28-16.25,7.81-2.14,19.21-5.33,19.21-5.33a20.33,20.33,0,0,0,.31-2.41c-7.17,1.45-19.38,4.5-23.82,6.39-5.31,2.26-4.51,9-7.56,18.17s-12.87,14.86-20.29,15.12S238,251.09,236.36,244.33A135.14,135.14,0,0,0,228,220.59c-2.77-5.68-4.22-13.21-2.93-17.7-.91,2.77-1.5,6.92-.45,12.73,1.75,9.73,6.2,20.42,8.65,30.18,4.18,16.65,9.29,21.69,19.63,18.75S269.72,254.81,272.1,246Z"
            style={{
              opacity: 0.1,
              transformOrigin: "262.481px 234.115px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="eliy1jassqzfi">
          <path
            d="M277.79,212.47l-4.21.83,19.26-10.84a12.81,12.81,0,0,0-2.36-12.58c-.13-.16-.26-.3-.39-.45,2,3.31,1.48,7.06-4.33,10.79-5.63,3.6-9.6,5.87-14.94,9.18-4.62,2.86-.33,10.35,2.37,10.58S275.29,213,277.79,212.47Z"
            style={{
              opacity: 0.1,
              transformOrigin: "281.171px 204.708px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="el5fcgo1tjvfp">
          <path
            d="M292.84,202.46a12.66,12.66,0,0,0,.43-7,5.53,5.53,0,0,1-2.75,5.59c-1.66.95-15.12,8.52-18.22,10.3s0,5.72.95,5.36-.22-2.49.33-3.44Z"
            style={{
              opacity: 0.1,
              transformOrigin: "282.264px 206.097px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Character--inject-64"
      style={{
        transformOrigin: "374.923px 260.262px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--Chartacter--inject-64"
        style={{
          transformOrigin: "374.923px 260.262px 0px",
        }}
        className="animable"
      >
        <g
          id="freepik--Bottom--inject-64"
          style={{
            transformOrigin: "404.534px 333.339px 0px",
          }}
          className="animable"
        >
          <path
            d="M431.53,429.88c.56,5.34,1.56,8.85,3.6,11.91s5.63,3.68,9.27,2.78a13.83,13.83,0,0,0,9.8-8.71c1.18-3.59.47-7.83-.58-12.76Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "443.171px 434.024px 0px",
            }}
            id="elxbdjrh6ut49"
            className="animable"
          />
          <path
            d="M445,390.13c1.5.05,2.28,7.22,3.48,14.38,1.28,7.68,3.84,11.89,4.85,17.06,1.4,7.16,1.05,10.43-1.28,14.92s-11.95,9.48-16.66,3.42c-3.85-4.93-4.26-10.59-4.26-17.83a183.61,183.61,0,0,0-.52-18.39c-.54-5.4-1.16-10.63.11-11.3.14.79.28,1.8.43,2.57.11.6.39,3.53,1.23,3.51a10.78,10.78,0,0,0-.08-2,2.38,2.38,0,0,1,.33-1.76,2.83,2.83,0,0,1,1.63-.82,41.66,41.66,0,0,1,4.42-.89,18.66,18.66,0,0,1,2.23-.2,12.22,12.22,0,0,1,2.76-.1,1.3,1.3,0,0,1,.84.69,2.3,2.3,0,0,1,.12.82,5.75,5.75,0,0,0,.26,1.48c.06.21.22.47.43.4s.23-.27.23-.45c0-.87-.18-1.5-.27-2.51,0-.47-.14-1.1-.17-1.58S445.09,390.59,445,390.13Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "442.065px 416.422px 0px",
            }}
            id="elekvtyu1k1aj"
            className="animable"
          />
          <g id="elhov36rq79b7">
            <path
              d="M448,423.61a.53.53,0,0,1-.45.59.52.52,0,0,1-.15-1A.52.52,0,0,1,448,423.61Z"
              style={{
                opacity: 0.15,
                transformOrigin: "447.54px 423.696px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elh3hbojimmw">
            <path
              d="M447.22,418.64a.52.52,0,1,1-1,.15.51.51,0,0,1,.44-.59A.52.52,0,0,1,447.22,418.64Z"
              style={{
                opacity: 0.15,
                transformOrigin: "446.736px 418.777px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elnr3z4lhd5kc">
            <path
              d="M446.53,414a.52.52,0,0,1-.44.6.54.54,0,0,1-.6-.44.53.53,0,0,1,1-.16Z"
              style={{
                opacity: 0.15,
                transformOrigin: "446.014px 414.154px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="el8bjde28n49i">
            <path
              d="M445.85,409.33a.54.54,0,0,1-.44.6.53.53,0,0,1-.16-1A.52.52,0,0,1,445.85,409.33Z"
              style={{
                opacity: 0.15,
                transformOrigin: "445.404px 409.426px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elnh3wfo9zokd">
            <path
              d="M435.21,410.7a.52.52,0,1,1-.59-.44A.51.51,0,0,1,435.21,410.7Z"
              style={{
                opacity: 0.15,
                transformOrigin: "434.695px 410.774px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elmkkxo8dc8o">
            <path
              d="M435.9,415.35a.52.52,0,0,1-.44.6.54.54,0,0,1-.6-.44.53.53,0,0,1,1-.16Z"
              style={{
                opacity: 0.15,
                transformOrigin: "435.383px 415.505px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elmuq7964i5y8">
            <path
              d="M436.59,420a.52.52,0,1,1-1,.16.52.52,0,0,1,.44-.6A.53.53,0,0,1,436.59,420Z"
              style={{
                opacity: 0.15,
                transformOrigin: "436.106px 420.138px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elifcaberrsi">
            <path
              d="M437.33,425a.53.53,0,0,1-1,.16.52.52,0,0,1,.44-.6A.54.54,0,0,1,437.33,425Z"
              style={{
                opacity: 0.15,
                transformOrigin: "436.826px 425.007px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elmsbru9bv8g">
            <polygon
              points="441.84 427.16 436.2 392.52 438.13 392.39 441.84 427.16"
              style={{
                opacity: 0.15,
                transformOrigin: "439.02px 409.775px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M447.47,424h-.08c-3.49-.61-8.2.1-10.46,1.34a.27.27,0,0,1-.36-.11.27.27,0,0,1,.1-.36c2.4-1.31,7.16-2,10.81-1.4a.27.27,0,0,1,0,.53Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "442.118px 424.311px 0px",
            }}
            id="elnv4huunnh3c"
            className="animable"
          />
          <path
            d="M446.74,419a.23.23,0,0,1-.14,0c-2.69-1.12-7.82,0-10.4,1.36a.27.27,0,0,1-.36-.1.27.27,0,0,1,.1-.37c2.69-1.47,8-2.57,10.87-1.38a.27.27,0,0,1,.14.35A.26.26,0,0,1,446.74,419Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "441.387px 419.199px 0px",
            }}
            id="elr2d7c7a7we"
            className="animable"
          />
          <path
            d="M446.05,414.29a.23.23,0,0,1-.14,0c-2.7-1.12-7.82,0-10.4,1.36a.26.26,0,0,1-.26-.46c2.69-1.48,8-2.58,10.86-1.39a.28.28,0,0,1,.15.35A.26.26,0,0,1,446.05,414.29Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "440.696px 414.49px 0px",
            }}
            id="elc3ilsnvay5"
            className="animable"
          />
          <path
            d="M445.37,409.67a.22.22,0,0,1-.14,0c-2.7-1.12-7.83,0-10.41,1.36a.26.26,0,1,1-.25-.46c2.69-1.48,8-2.58,10.86-1.39a.27.27,0,0,1,.15.35A.26.26,0,0,1,445.37,409.67Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "440.016px 409.869px 0px",
            }}
            id="elzk4lnk0l9z"
            className="animable"
          />
          <polygon
            points="396.26 409.66 389.81 407.69 391.6 403.3 395.7 406.66 396.26 409.66"
            id="elpc53va4i8f"
            style={{
              transformOrigin: "393.035px 406.48px 0px",
            }}
            className="animable"
          />
          <path
            d="M402.05,397.89s.51,4.08.65,5.37-5.12,5.65-6.44,6.4l-.56-3c-1.1,1.26-1.71,2.8-2.84,5.09-.95,1.91-2.08,5.48-4.84,8-4.11,3.8-10.74,6-17.6,6.7s-10.91-.76-13-2.13-2.78-3.07-2.4-4.85S402.05,397.89,402.05,397.89Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "378.812px 412.261px 0px",
            }}
            id="elxjlx07rzgg"
            className="animable"
          />
          <path
            d="M382.77,385.05l-.23-2.37c-1.27,0-1.21,3.5-2.87,6.64a61.81,61.81,0,0,1-8.9,13c-6.58,6.79-12.55,11.18-15.48,14.24-3.92,4.09,3.78,9.71,15,8.38,5.56-.67,15.28-4.09,17.85-7.56s4-8.71,6-11.25,6.71-5.24,7.91-8.23c.67-1.65,0-5.34-.63-8.48-.6-2.88-1-7.32-2.58-6.86l0,1.5c-.59,1.31-2,3.51-6.45,4.55C390.15,389.12,383.47,389.74,382.77,385.05Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "378.292px 403.833px 0px",
            }}
            id="elb2wxch78i7s"
            className="animable"
          />
          <g id="elfeeg72h93rc">
            <path
              d="M388.77,388.94c-2.16,0-4.51-.61-5.53-2.49,0,0,0,0-.05-.06a5.46,5.46,0,0,1-1.16,4.67c-1.86,2.47-13.5,19.84-13.5,19.84s11-14.41,13.05-17.13c3.11-4,4.14-4.52,7.2-4.82Z"
              style={{
                opacity: 0.15,
                transformOrigin: "378.655px 398.645px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="eltrl1oaxe84">
            <path
              d="M386.24,393.51a.69.69,0,1,0,.56-.79A.68.68,0,0,0,386.24,393.51Z"
              style={{
                opacity: 0.15,
                transformOrigin: "386.92px 393.399px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elgowi5fygkmk">
            <path
              d="M383.16,397.38a.68.68,0,1,0,.56-.79A.67.67,0,0,0,383.16,397.38Z"
              style={{
                opacity: 0.15,
                transformOrigin: "383.829px 397.261px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elyyweip8c9fr">
            <path
              d="M380.07,401.26a.69.69,0,1,0,.56-.8A.69.69,0,0,0,380.07,401.26Z"
              style={{
                opacity: 0.15,
                transformOrigin: "380.749px 401.14px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elh1pt4eetclu">
            <path
              d="M377,405.13a.69.69,0,1,0,.56-.8A.7.7,0,0,0,377,405.13Z"
              style={{
                opacity: 0.15,
                transformOrigin: "377.68px 405.01px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elr54mknm8m3">
            <path
              d="M373.91,409a.69.69,0,1,0,.56-.8A.69.69,0,0,0,373.91,409Z"
              style={{
                opacity: 0.15,
                transformOrigin: "374.589px 408.88px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M387,393.67a.28.28,0,0,0,.17-.1.28.28,0,0,0,0-.39c-.15-.12-3.65-3.1-8-2.58h0a.28.28,0,1,0,.07.55c4.06-.49,7.49,2.42,7.53,2.45A.26.26,0,0,0,387,393.67Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "383.068px 392.107px 0px",
            }}
            id="elm0lcv0datw"
            className="animable"
          />
          <path
            d="M383.87,397.53a.23.23,0,0,0,.17-.1.27.27,0,0,0,0-.39c-.14-.12-3.65-3.1-7.95-2.58h0a.27.27,0,0,0-.23.31.26.26,0,0,0,.3.24c4.06-.49,7.5,2.42,7.53,2.45A.27.27,0,0,0,383.87,397.53Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "379.99px 395.965px 0px",
            }}
            id="el8wjy1t19my"
            className="animable"
          />
          <path
            d="M380.79,401.41a.28.28,0,0,0,.17-.09.27.27,0,0,0,0-.39c-.14-.13-3.65-3.11-7.95-2.59h0a.28.28,0,0,0-.23.31.26.26,0,0,0,.3.24c4.06-.49,7.5,2.43,7.53,2.46A.29.29,0,0,0,380.79,401.41Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "376.911px 399.845px 0px",
            }}
            id="el45cxnfs58sy"
            className="animable"
          />
          <path
            d="M377.71,405.28a.32.32,0,0,0,.17-.09.27.27,0,0,0,0-.39c-.15-.13-3.65-3.11-8-2.58h0a.27.27,0,1,0,.07.54c4.06-.49,7.49,2.43,7.53,2.46A.29.29,0,0,0,377.71,405.28Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "373.803px 403.72px 0px",
            }}
            id="el6gio023b9oe"
            className="animable"
          />
          <path
            d="M374.62,409.15a.26.26,0,0,0,.17-.09.27.27,0,0,0,0-.39c-.15-.13-3.65-3.11-8-2.58h0a.28.28,0,0,0,.08.55c4.05-.5,7.49,2.42,7.52,2.45A.31.31,0,0,0,374.62,409.15Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "370.729px 407.59px 0px",
            }}
            id="elitdnwbz7b1q"
            className="animable"
          />
          <path
            d="M439,221.73c5.74,39.35,7.16,94.5,7.16,94.5a179.06,179.06,0,0,1,3.34,27.44c.65,15.73.3,59,.3,59s-10.37,6.85-21.33,1.85c0,0-9.71-49.24-14-72-3.47-18.15-7.45-42.71-7.45-42.71l-2.59,21.92s2.42,13.5,2,25.43c-.31,9.2-4,54.27-4,54.27s-14.69,7.16-25.17-2.7c0,0-4.55-66.91-5.56-77.93-2-21.61-.41-59.6-1.54-87.6Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "410.027px 314.038px 0px",
            }}
            id="elpklxo3rczw"
            className="animable"
          />
          <path
            d="M407,290.2l-6.81-37.3s-10.56-.84-16.26-5.41c0,0,3.9,6.29,13.94,8.17l6.37,33.82.17,22.64Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "395.465px 279.805px 0px",
            }}
            id="elygwqdhv08bo"
            className="animable"
          />
        </g>
        <g
          id="freepik--Top--inject-64"
          style={{
            transformOrigin: "406.138px 156.642px 0px",
          }}
          className="animable"
        >
          <path
            id="freepik--Chest--inject-64"
            d="M415.65,134.75c4.16.71,9.18,1.63,9.18,1.63,10.61,4.3,15.21,6.37,17.44,7.25a192.66,192.66,0,0,1-1.48,36.27c-.56,4.25-.94,16.31-.73,25.19.29,12,.7,25.91.7,25.91s-12.58,7.79-41.84,6.58c-23-1-29.19-8.14-29.19-8.14s.46-34.46.48-51.38c0-22.23,6.2-34.92,11-39l14.6-3.45Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "406.138px 186.229px 0px",
            }}
            className="animable"
          />
          <g
            id="freepik--Head--inject-64"
            style={{
              transformOrigin: "403.713px 113.553px 0px",
            }}
            className="animable"
          >
            <g
              id="freepik--head--inject-64"
              style={{
                transformOrigin: "403.713px 113.553px 0px",
              }}
              className="animable"
            >
              <path
                d="M424.18,90.9c-1.84-4.6-5.62-5-5.62-5-1.16-4.91-9-10.75-18.95-10.3-12.41.55-17.5,4.61-19.55,10.87a14.32,14.32,0,0,0,1.67,11.81l29.2-3.15a26.5,26.5,0,0,0,.35,4.13c.7,4.4,5,9.57,5,9.57l0,6.17.3,8.85a120.51,120.51,0,0,0,6.46-15.76C425.36,100.79,425.53,94.29,424.18,90.9Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "402.248px 99.7128px 0px",
                }}
                id="el6v7i7le6kcw"
                className="animable"
              />
              <path
                d="M421.43,100.21a1.74,1.74,0,0,1-2.36-.75c-.16-.39-.17-.86-.45-1.17s-1.05-.34-1.58-.53a1.58,1.58,0,0,1-.81-.67,7.29,7.29,0,0,0-.6-1.33c-.66-.79-2-.41-2.82-1.08-.44-.39-.58-1-1-1.42a6.8,6.8,0,0,0-.91-.51,1.65,1.65,0,0,1-.76-1c-.07-.38.06-1,.46-1.16a3,3,0,0,1,1.55.19,2,2,0,0,1,1.45,2,1.16,1.16,0,0,0,.89,1.45c.49.15,1,.15,1.49.27a1.46,1.46,0,0,1,1.11.93,4.07,4.07,0,0,1,0,.78c0,1.16,1.75,1,2.47,1.47a.87.87,0,0,1,.33.38c.13.31,0,.66,0,1C420,99.86,420.81,100,421.43,100.21Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "415.776px 95.485px 0px",
                }}
                id="elqo688c1qo6b"
                className="animable"
              />
              <path
                d="M419.26,102.23a1.74,1.74,0,0,1-2.35-.75c-.16-.39-.17-.86-.45-1.17s-1-.34-1.58-.53a1.53,1.53,0,0,1-.81-.67,7.29,7.29,0,0,0-.6-1.33c-.66-.79-2-.41-2.82-1.08-.44-.39-.58-1-1-1.42a6.34,6.34,0,0,0-.92-.51,1.67,1.67,0,0,1-.75-1c-.07-.38.06-1,.46-1.16a3,3,0,0,1,1.55.19,2,2,0,0,1,1.45,2,1.16,1.16,0,0,0,.89,1.45c.48.15,1,.15,1.49.28a1.4,1.4,0,0,1,1.1.92,3.38,3.38,0,0,1,0,.78c0,1.16,1.75,1,2.47,1.47a.87.87,0,0,1,.33.38c.13.31,0,.66,0,1C417.81,101.88,418.65,102,419.26,102.23Z"
                style={{
                  fill: "rgb(69, 90, 100)",
                  transformOrigin: "413.611px 97.5029px 0px",
                }}
                id="elq5q6y9cylle"
                className="animable"
              />
              <path
                d="M424,117c-3.15,2.3-6.26-.89-6.26-.89l.31,17.28s-.05,4.52-5.47,7.94c-8.11,2.94-11.94,5.89-15.82,10.2l-1.85,0c-1.29-6.82-2.33-9.23.11-16.92v-4.41a17.24,17.24,0,0,1-3.8,0c-4.09-.4-6.83-3.46-8.3-7.78-2.36-7-2.71-19.29.22-32,5.12-4.39,18.39-4.6,28.28.89,0,8.09,2.47,11.55,2.62,14.48a7.39,7.39,0,0,0,1.89,2.17c1.56,1.2,2.57-2.2,3.74-3.58s5.14-3.38,7.42.78S426.76,115,424,117Z"
                style={{
                  fill: "rgb(177, 102, 104)",
                  transformOrigin: "404.503px 119.343px 0px",
                }}
                id="eldtfu1mfm23p"
                className="animable"
              />
              <path
                d="M401,98.53l4.29,2.32a2.55,2.55,0,0,0-1-3.39A2.37,2.37,0,0,0,401,98.53Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "403.289px 99.0078px 0px",
                }}
                id="eln61qajoxn0b"
                className="animable"
              />
              <path
                d="M383.93,99.69,388.57,98a2.37,2.37,0,0,0-3.06-1.55A2.6,2.6,0,0,0,383.93,99.69Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "386.187px 98.0021px 0px",
                }}
                id="elvb69b5w41ys"
                className="animable"
              />
              <path
                d="M403.37,103.4a2,2,0,1,1-2-1.94A2,2,0,0,1,403.37,103.4Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "401.371px 103.46px 0px",
                }}
                id="elj3jami3y7g7"
                className="animable"
              />
              <path
                d="M388.94,103.31a2,2,0,1,1-2-1.94A1.81,1.81,0,0,1,388.94,103.31Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "386.943px 103.365px 0px",
                }}
                id="el85d1ular6g3"
                className="animable"
              />
              <path
                d="M396.79,98.74l-2,12.82-6.59-1.65C390.61,104.18,394,99.63,396.79,98.74Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "392.495px 105.15px 0px",
                }}
                id="elc6aggfy3mdb"
                className="animable"
              />
              <path
                d="M408.37,103a1.41,1.41,0,0,0-.52-.32l-.33-.09a6.29,6.29,0,0,0-.74-.11,3.64,3.64,0,0,0-1.5.16c-.12,0-.07.32.05.34a13,13,0,0,0,1.54.1,4.52,4.52,0,0,1,.63.08l.34.1.14,0,.21.06h.12C408.5,103.43,408.45,103.12,408.37,103Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "406.826px 102.902px 0px",
                }}
                id="eljh9s05dz8v8"
                className="animable"
              />
              <path
                d="M407,104.84c-.08-.06-.14-.14-.22-.19a2.9,2.9,0,0,0-.75-.31,3.58,3.58,0,0,0-.45-.09,2.57,2.57,0,0,0-.48,0c-.17,0-.1.37,0,.39a5.72,5.72,0,0,1,.84.2l.35.13c.13,0,.24.12.36.17s.3.14.37,0A.26.26,0,0,0,407,104.84Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "406.028px 104.727px 0px",
                }}
                id="elam4elhlrvz7"
                className="animable"
              />
              <path
                d="M382.09,103.1h0l-.09-.06A.14.14,0,0,0,382.09,103.1Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "382.045px 103.07px 0px",
                }}
                id="elk2z2eeluvkk"
                className="animable"
              />
              <path
                d="M383.94,102.88a1.42,1.42,0,0,0-.56-.18q-.35-.06-.69-.09l-.49,0h-.3a.42.42,0,0,0-.31.13c-.13.15,0,.38.14.46l.1,0a1.36,1.36,0,0,0,.57.07H383l.47,0a.84.84,0,0,0,.47-.08C384.09,103.16,384,102.94,383.94,102.88Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "382.779px 102.943px 0px",
                }}
                id="elykic3jomlal"
                className="animable"
              />
              <polygon
                points="382.11 103.12 382.1 103.11 382.1 103.11 382.11 103.12"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "382.105px 103.115px 0px",
                }}
                id="elfrv3qninxqs"
                className="animable"
              />
              <path
                d="M384,104.25a1.3,1.3,0,0,0-.52,0l-.46,0-.81,0a.25.25,0,0,0-.2.34.44.44,0,0,0,.4.31h.28l.2,0,.43,0a3,3,0,0,0,.43-.1c.11,0,.28-.09.34-.2S384.09,104.29,384,104.25Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "383.053px 104.562px 0px",
                }}
                id="els01ltc4bhoo"
                className="animable"
              />
              <path
                d="M382.71,104.89Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "382.71px 104.89px 0px",
                }}
                id="elg4fo0kpn7gm"
                className="animable"
              />
              <path
                d="M402.07,94c-1.1-.47-2.59-.11-3.72,0a20.11,20.11,0,0,1-3.79.36c-2.32-.11-4.72-1.56-7.06-.83-.05,0-.07.14,0,.13a9.15,9.15,0,0,1,3.67.54,15.12,15.12,0,0,0,3.49.81,14.61,14.61,0,0,0,3.84-.39c.58-.12,1.17-.24,1.77-.33a9.78,9.78,0,0,0,1.79-.26S402.1,94,402.07,94Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "394.768px 94.1713px 0px",
                }}
                id="elb91w04ix4mh"
                className="animable"
              />
              <path
                d="M414.13,104.6c-.34,8.69-3.32,9.32-6.4,9.85-4.08.71-6.12-1.49-13.43-1.42-4.43,0-5.81,1.36-8.32,2.42-1.86.78-3.79.69-4.1-1.1a62,62,0,0,1-.62-11.24,81.29,81.29,0,0,0,0,15.77c.64,4.08,1.75,7.89,4,9.78,3.14,2.62,9.73,3,17.89,1.09s11.16-4.61,12.12-7.5c3.11-9.39,1.82-13.81,2.88-15.59S414.13,104.6,414.13,104.6Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "399.586px 117.029px 0px",
                }}
                id="elgx5pjf3jlgq"
                className="animable"
              />
              <path
                d="M395.32,115.62c4.18-.12,5.55.63,5.77,3.48.32,4.09.13,5.47-1.43,5.69-1.84.27-3.19.39-3.26-.77a4.5,4.5,0,0,1,.24-2.62c.64-.78.41-.9-1.42-.84s-1.8.38-1.26.94c.4.41.38,1.81.38,2.62s-.19,1.22-2.82,1c-2.3-.2-1.93-2-1.91-5.56C389.62,117.19,390.6,115.76,395.32,115.62Z"
                style={{
                  fill: "rgb(177, 102, 104)",
                  transformOrigin: "395.399px 120.393px 0px",
                }}
                id="elikgpvpnaai"
                className="animable"
              />
              <path
                d="M398.05,116.65l-5.55.81a2.75,2.75,0,0,0,3.12,2.45A2.92,2.92,0,0,0,398.05,116.65Z"
                style={{
                  fill: "rgb(154, 74, 77)",
                  transformOrigin: "395.287px 118.293px 0px",
                }}
                id="elmm5durjwque"
                className="animable"
              />
              <path
                d="M397.33,117.49a2.93,2.93,0,0,1,.67.06,2.88,2.88,0,0,1-2.38,2.36,2.46,2.46,0,0,1-.9,0A2.58,2.58,0,0,1,397.33,117.49Z"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "396.36px 118.72px 0px",
                }}
                id="els31d7g3cpep"
                className="animable"
              />
            </g>
          </g>
          <g
            id="freepik--Tie--inject-64"
            style={{
              transformOrigin: "405.553px 175.83px 0px",
            }}
            className="animable"
          >
            <path
              d="M392.41,154.2s-3.39-5.88-3.47-8.26l3.74-4.14,1.48,9.74Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "391.55px 148px 0px",
              }}
              id="elq5plzdgdoc"
              className="animable"
            />
            <polygon
              points="397.35 151.56 403.8 146.84 409.44 150.35 399.48 155.89 397.35 151.56"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "403.395px 151.365px 0px",
              }}
              id="elennnvlsazfo"
              className="animable"
            />
            <path
              d="M399,214.83c1.22-13.65-2.07-50.78-1.88-55.61l-3.38-.21c-2.13,5.87-7.38,44.24-7.38,53.6,0,4.51,4.55,12.42,6,12.68S398.78,217.73,399,214.83Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "392.816px 192.153px 0px",
              }}
              id="elgmhgypcfpvr"
              className="animable"
            />
            <path
              d="M393.51,159.86c.08-.28.19-.62.27-.85h0l3.38.21h0c0,.4,0,.92,0,1.51A5.94,5.94,0,0,1,393.51,159.86Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "395.335px 159.881px 0px",
              }}
              id="el0qy89jfb6ey"
              className="animable"
            />
            <path
              d="M397.35,151.56a14.22,14.22,0,0,0-3.19,0,7.57,7.57,0,0,0-1.75,2.66,11.53,11.53,0,0,0,1.37,4.81,4,4,0,0,0,3.38.21,7.11,7.11,0,0,0,2.32-3.33A6.41,6.41,0,0,0,397.35,151.56Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "395.945px 155.494px 0px",
              }}
              id="eltk5nvi7dse"
              className="animable"
            />
            <path
              d="M396.79,151.5l.56.06a20.63,20.63,0,0,1,3.95-3.41c.93-.46,4.61,6.18,5.29,7.91s.56,1.7,2.93.23a45.72,45.72,0,0,0,10.88-9.81,29.25,29.25,0,0,0,5.06-8.78,32.9,32.9,0,0,1-3.86-4.63c-1.42-2.75-2.1-6.88-3.65-6.7l-.55,3.12c-.34,2.34-3.45,5.92-6.84,8.65s-7.88,5.53-9.18,6.7A48,48,0,0,0,396.79,151.5Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "411.125px 141.87px 0px",
              }}
              id="el75bkl7j8344"
              className="animable"
            />
            <path
              d="M385.79,151.36c.34,1,3.64-6.45,5.14-6.24.72.08,2.5,4.18,3.77,6.37h.24c-.23-2.89-.5-5.36-.48-6.89,0-2.79.6-7.54.6-7.54v-6.19c-.51,0-1.06,0-1.48.07a7.42,7.42,0,0,0-1.16,1.38c-1.54,2.35-5.55,7.77-6.12,10.63A25.31,25.31,0,0,0,385.79,151.36Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "390.353px 141.18px 0px",
              }}
              id="elfo887bs0w5f"
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Arm--inject-64"
          style={{
            transformOrigin: "331.116px 151.63px 0px",
          }}
          className="animable"
        >
          <path
            d="M318.77,149.11c7.72,4.68,22.7,14.26,22.7,14.26s13.43-11.16,16.81-13.81c9.68-7.56,11.12-9,20.06-9.92l-.65,24.3c-8.81,6.71-24.07,15.84-33.44,20.8-4.75,2.52-7.43,1.49-13.27-3.54-7.44-6.4-24.16-22.4-24.16-22.4Z"
            style={{
              fill: "rgb(177, 102, 104)",
              transformOrigin: "342.58px 162.851px 0px",
            }}
            id="el0en73rglplf"
            className="animable"
          />
          <path
            d="M378.62,139c-7.87,2-10.37,2.22-15.38,5.85-3.92,2.83-22,18.09-22,18.09l-9.78-6.29s.77,2.9-4.58,8.74c-2.76,3-9.06,4.75-9.06,4.75s5.21,4.78,10.29,9.38c3.56,3.22,7.13,7.12,10.73,7.47s6.11-1.62,16.53-7.56a244.51,244.51,0,0,0,23.22-15.22Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "348.22px 163.014px 0px",
            }}
            id="elbg266vzjrkk"
            className="animable"
          />
          <g id="eltmh0fmtnj4">
            <path
              d="M341.48,162.51a22.68,22.68,0,0,1,4.81,11.22,18.26,18.26,0,0,0-3.3-12.38Z"
              style={{
                opacity: 0.1,
                transformOrigin: "343.929px 167.54px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M319.66,149.65c-5.94-3.63-9.63-7.09-10.33-12.36s-.32-8.07-.9-9.2-5.28-5.65-6.74-8-2.57-1.95-4.82-2.56c-2.69-.74-13.27-1.83-13.24-1a4.32,4.32,0,0,0,2.7,4.4c2,.89,7.75,1.73,7.75,1.73s-1.5,2.39-2.24,3.41-.48,1.75,1.13,4.56c0,0-1.31.79-1.37,1.9a6.49,6.49,0,0,0,1,3.12,3,3,0,0,0-1.12,1.52c-.29,1,.85,3.38,2.15,5.36a33.72,33.72,0,0,0,2.43,7.78c1.26,2.54,3.1,3.37,5.18,4.3,1.4.62,5.46,4.05,7.06,5.35C308.26,160,325.09,153,319.66,149.65Z"
            style={{
              fill: "rgb(177, 102, 104)",
              transformOrigin: "302.176px 138.096px 0px",
            }}
            id="elo2to21eazcd"
            className="animable"
          />
          <path
            d="M305.61,129.51a9.91,9.91,0,0,1-4.44-4.63c-.85-2-1.65-4.25-2.34-4.18-1.16.11-3,2.62-1.95,6,1,3.21,3.12,6.85,3.36,7.79s-.28,3.3-.74,5.12a9.12,9.12,0,0,0,4.34,9.54,8.43,8.43,0,0,1-4.82-4c-2.07-3.43-.37-7.4-.16-9.22s.25-2.18-1.23-5-3.1-5.95-1.16-9.21,3.2-2,3.74-1S302.29,127.67,305.61,129.51Z"
            style={{
              fill: "rgb(154, 74, 77)",
              transformOrigin: "300.595px 134.386px 0px",
            }}
            id="eloct22szpsuk"
            className="animable"
          />
          <path
            d="M294.08,122.68l2.28.77-.61.65a2.79,2.79,0,0,0-2.95.58Z"
            style={{
              fill: "rgb(154, 74, 77)",
              transformOrigin: "294.58px 123.68px 0px",
            }}
            id="el3rygz8k35al"
            className="animable"
          />
          <path
            d="M293,130.65c.5.94,2.22,3.77,2.57,4.35s1.48.23,2-1a4.4,4.4,0,0,0,.27-3.24,4.8,4.8,0,0,1,.26,3.41c-.62,1.64-1.69,2-2.39,1.87S294.05,132.66,293,130.65Z"
            style={{
              fill: "rgb(154, 74, 77)",
              transformOrigin: "295.649px 133.357px 0px",
            }}
            id="elaujwodyvj4i"
            className="animable"
          />
          <path
            d="M292.56,135.67c.37.71,1,1.6,2.08,3.55.61,1.13.95,1.87,1.68,1.68s1.79-1.92,1.42-3.34a10.71,10.71,0,0,0-.91-2.38l.55-.33a8.42,8.42,0,0,1,1.12,3.83c-.07,1.78-1.57,3.37-2.39,3s-1.14-1-1.94-2.65S292.56,135.67,292.56,135.67Z"
            style={{
              fill: "rgb(154, 74, 77)",
              transformOrigin: "295.53px 138.292px 0px",
            }}
            id="elgz5uy8bfdq"
            className="animable"
          />
          <path
            d="M295.78,141.14c.19.49.07,1.66-.76,1.81a1.84,1.84,0,0,1-1.43-.4,1.54,1.54,0,0,0,1.59.83c1-.18,1.35-1.28,1.39-2.18Z"
            style={{
              fill: "rgb(154, 74, 77)",
              transformOrigin: "295.08px 142.268px 0px",
            }}
            id="el662qim4sj6g"
            className="animable"
          />
        </g>
        <path
          d="M418,129.73l.08,1.78s2,5.4-1,15.82-9.37,24.17-9.45,34.65,5.89,111.37,5.89,111.37,28.32-.44,36.61-11.89c-.28-8.91-6.18-40.16-7.58-61.84-.65-10.09.48-26.6,1.76-42.6a145.88,145.88,0,0,0-1.92-35.38,55.94,55.94,0,0,1-15.34-5.46C420.68,132.59,418,129.73,418,129.73Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "428.88px 211.54px 0px",
          }}
          id="elo81i6cgy29"
          className="animable"
        />
        <path
          d="M417.94,125.59c3.26,0,6.89,9.37,9.11,10.59,1.07,7.39-1.25,21.06-1.51,25.45s-8.34,10.11-8.34,10.11l6.62,11.72s-15.11,21.78-14.91,33.26c0,0-3.63-27.55-1.48-39.69,1.95-11,10-31.84,10.57-47.41Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "417.04px 171.155px 0px",
          }}
          id="el0fub74zx6wi"
          className="animable"
        />
        <path
          d="M395.05,131.31v3.09a25.72,25.72,0,0,0-9,12.37c-3.14,8.62-6.92,22.67-7.75,45.42-1.67,46.13-1.82,98.24-1.82,98.24a22.45,22.45,0,0,1-13.15-5.06s0-37.37.87-62.63c1-30.13.69-45.05,1.35-57.44.82-15.7,8.42-23.33,11.8-26C382.86,137.72,391.71,135.48,395.05,131.31Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "379.19px 210.87px 0px",
          }}
          id="elw3me8dk51od"
          className="animable"
        />
        <path
          d="M395.05,130.9v3.78a22,22,0,0,0-6,7.07c-2.27,4.39-5.09,8.74-7.43,22.29s-3.46,36.58-4,45.4c-1.19-3.66-5.94-31.67-6.2-34.18s5.94-10.45,5.94-10.45-2.56-6.28-1.54-9.13a140.18,140.18,0,0,1,10.6-19.54,24.14,24.14,0,0,1,5-5.33A23.34,23.34,0,0,0,395.05,130.9Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "383.231px 170.125px 0px",
          }}
          id="elyz0kb9we1p"
          className="animable"
        />
        <path
          d="M410.35,144l-.73-.84c7.49-6.53,13-16.78,13.59-18.1,0,0,1.39-4,.23-10.46l1.1-.2c1.22,6.83-.23,10.91-.29,11.08C423.54,127.1,418,137.31,410.35,144Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "417.323px 129.2px 0px",
          }}
          id="elxyd4w5kpanj"
          className="animable"
        />
        <path
          d="M395.05,130.91c0,.31,0,.63,0,1l-.6,1.12a2.07,2.07,0,0,0-1-.47c.32-.64.59-1.15.87-1.64Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "394.25px 131.97px 0px",
          }}
          id="el33vd5u6rcgo"
          className="animable"
        />
        <path
          d="M424.6,111.11h0a2.56,2.56,0,1,0-2.72,3.63h0s1,0,1.32,1.48a9.73,9.73,0,0,1,.29,2.82,1.49,1.49,0,0,0,1.8-.39C425.68,116.68,425.36,112.39,424.6,111.11Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "422.593px 114.422px 0px",
          }}
          id="eltibn8yqcj9"
          className="animable"
        />
        <path
          d="M356.14,178.36a52.2,52.2,0,0,1-7.05-.5c-29.21-4-47.55-32.11-53.57-41.35l1.67-1.09c5.91,9.05,23.86,36.59,52.17,40.46,17.62,2.41,31.52-4.41,41.34-20.28l1.7,1.05C383.48,171.08,371.3,178.36,356.14,178.36Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "343.96px 156.89px 0px",
          }}
          id="elwyc533ictf"
          className="animable"
        />
        <path
          d="M416.87,137.9a105,105,0,0,1-9.37,9.9c-2.3,1.87-8.57,6.77-13,8.58a7.81,7.81,0,0,1-2.72.68,2.9,2.9,0,0,1-.75-.1c-.77-.26-3.1-1-2.4-14.11.12-2.3,3.45-8.8,4.12-10.07a.62.62,0,0,1,.65-.21,2.07,2.07,0,0,1,1,.47c.28.24.44.52.3.77-1.45,2.79-3.78,7.74-3.86,9.16-.36,6.69.19,11.3.93,11.89.47.15,1.55-.24,3-1A78.54,78.54,0,0,0,406,146.12a107.66,107.66,0,0,0,9.07-9.6C415.73,135.9,417.29,137.34,416.87,137.9Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "402.721px 144.804px 0px",
          }}
          id="el7b3g5u24upu"
          className="animable"
        />
        <path
          d="M300.87,129.83a7.5,7.5,0,0,0-3.87-5.54,2,2,0,0,0-2.06.1l-2.28,1.75a2.75,2.75,0,0,0-.75,2.64,7.51,7.51,0,0,0,3.88,5.54,2,2,0,0,0,2-.1l2.28-1.74A2.78,2.78,0,0,0,300.87,129.83Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "296.385px 129.296px 0px",
          }}
          id="elivlcyywtnil"
          className="animable"
        />
        <path
          d="M298.59,131.57c.3,2.29-1,3.52-2.8,2.75a7.51,7.51,0,0,1-3.88-5.54c-.29-2.29,1-3.52,2.81-2.75A7.5,7.5,0,0,1,298.59,131.57Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "295.251px 130.175px 0px",
          }}
          id="eldp0udoizzed"
          className="animable"
        />
        <path
          d="M299.81,133.19c-.54-4.19-3.72-8.73-7.1-10.14a3.65,3.65,0,0,0-3.76.18l-1.46,1.11c-1.11.85-1.66,2.56-1.37,4.85.54,4.19,3.72,8.73,7.1,10.14a3.68,3.68,0,0,0,3.76-.18l1.46-1.11C299.55,137.19,300.1,135.48,299.81,133.19Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "292.965px 131.188px 0px",
          }}
          id="elnum803fgn5g"
          className="animable"
        />
        <path
          d="M298.35,134.29c.54,4.2-1.76,6.45-5.13,5s-6.56-6-7.1-10.14,1.76-6.45,5.14-5S297.81,130.1,298.35,134.29Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "292.235px 131.723px 0px",
          }}
          id="elwgt7dadm8ed"
          className="animable"
        />
        <path
          d="M297,133.73c.42,3.26-1.37,5-4,3.91s-5.1-4.62-5.52-7.88,1.37-5,4-3.92S296.57,130.47,297,133.73Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "292.24px 131.742px 0px",
          }}
          id="elt0nbabwxys"
          className="animable"
        />
        <path
          d="M301.07,125c-.78-2-1.27-4.36-2.2-4.26-1.16.13-3.13,2.53-2.14,5.92s2.95,6.93,3.15,7.88l5.48-4.78A9.87,9.87,0,0,1,301.07,125Z"
          style={{
            fill: "rgb(177, 102, 104)",
            transformOrigin: "300.91px 127.638px 0px",
          }}
          id="ely5f5hj95koo"
          className="animable"
        />
        <g
          id="freepik--arm--inject-64"
          style={{
            transformOrigin: "419.172px 184.158px 0px",
          }}
          className="animable"
        >
          <path
            d="M374.57,208a10.73,10.73,0,0,1,2.09.48c.75.24,1.44.51,2.22.68s1.63.35,2.45.49c1.15.21,2.3.47,3.47.61a25.9,25.9,0,0,0,6.64-.08c.7-.1,1.4-.22,2.09-.38.32-.07.72-.26.68-.59,0-.18-.19-.31-.34-.42-.86-.58-1.83-1-2.73-1.53a6.08,6.08,0,0,1-2.31-2.07c-.37-.63-.87-2.41-.07-3,.6-.41,1.83.3,2.38.54a22.22,22.22,0,0,0,3.67,1.29c1.36.32,2.76.42,4.12.72a14.32,14.32,0,0,1,5,2.14c1.4,1,2.67,2.14,4.16,3,2.84,1.59,7.42,1.25,11.53.66,8.42-1.22,23.35-5.57,23.35-5.57l-2.12-29c-1.92-8.63.48-29,5.21-31.76,2.05.65,7.53,1.11,12.07,8.3,2.47,3.93,3.69,13.43,5.13,29.48,1,11.41,1.86,18.45,1.81,28.77-.07,11.49-4.8,14.53-15.17,14.92-17.37.66-33.53.51-37.35.51s-7.53-.11-10.86-.41c-1.71-.15-3.43-.49-5.13-.55a11,11,0,0,1-6.2-1.82c-2.23-1.64-3.57-4.54-6.2-5.44a16.32,16.32,0,0,1-2.38-.72c-1.29-.67-1.9-2.1-2.91-3.08a13.87,13.87,0,0,0-2.14-1.49l-2.42-1.59a11.38,11.38,0,0,1-1.68-1.24,1.77,1.77,0,0,1-.41-.5C371.59,208.12,373.84,207.92,374.57,208Z"
            style={{
              fill: "rgb(177, 102, 104)",
              transformOrigin: "418.591px 185.207px 0px",
            }}
            id="elp1qbtk59cs"
            className="animable"
          />
          <path
            d="M442.39,141.64c13.53,2.57,16.1,6.92,17.51,12.52,1.91,7.51,3.39,19.05,5.26,37.52,1.43,14,1.14,21.28.78,24.24s-.91,8.64-10.7,10.07c-7.31,1.07-24.75.57-24.75.57s4.05-10.73-1.24-18l13.28-3.86-5.56-30S433.7,149.13,442.39,141.64Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "447.742px 184.158px 0px",
            }}
            id="el3na4ohzptv5"
            className="animable"
          />
          <g id="elkthhriaoyz8">
            <path
              d="M442.53,204.73s9.36-2.18,13.5-.66c0,0-3.62-3.29-14-2Z"
              style={{
                opacity: 0.1,
                transformOrigin: "449.03px 203.25px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="freepik--speech-bubble--inject-64"
      style={{
        transformOrigin: "289.21px 96.43px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--speech-bubble--inject-64"
        style={{
          transformOrigin: "289.21px 96.43px 0px",
        }}
        className="animable"
      >
        <rect
          x={226.03}
          y={52.7}
          width={126.36}
          height={38.4}
          rx={3.77}
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "289.21px 71.9px 0px",
          }}
          id="elg563dpvadta"
          className="animable"
        />
        <path
          d="M351.89,57.24h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V52.7h-1v4.54h-13V54.63a3.7,3.7,0,0,0-.5,1.84V87.32a3.7,3.7,0,0,0,.5,1.84V87.05h13v4h1v-4h13v4h1v-4h13v4h1v-4h13v4h1v-4h13v4h1v-4h13v4h1v-4h13v4h1v-4h13v4h1v-4h13v2.11a3.7,3.7,0,0,0,.5-1.84V56.47a3.7,3.7,0,0,0-.5-1.84ZM239.57,85.81h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Zm14,14.29h-13v-13h13Zm0-14.29h-13v-13h13Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "289.39px 71.875px 0px",
          }}
          id="elru3b0u8j8zj"
          className="animable"
        />
        <path
          d="M352.11,82.41c-.2-1-.32-2.14-.62-3.16a2.26,2.26,0,0,0-1.38-1.63,1.32,1.32,0,0,0-1.61.79,7.46,7.46,0,0,1-.53,1,3.15,3.15,0,0,1-.94.76c-.55.34-1.15.69-1.33,1.36-.12.44,0,1.06-.59,1.09-.31,0-.66,0-.92.15a1,1,0,0,0-.26.82c0,.88-.89.72-1.47.46s-1.37-.64-2-.24c-.34.22-.47.62-.79.86a1.5,1.5,0,0,1-1.59,0c-1-.59-1.13-1.92-1.26-2.93-.23-1.78-.35-3.6-.49-5.39-.27-3.46-.48-6.93-.69-10.39-.1-1.62-.2-3.24-.32-4.85a25,25,0,0,0-.31-2.86c-.06-.33-.62-.6-.71-.16a9.72,9.72,0,0,0-.12,1.7c-.07,1.26-.12,2.52-.18,3.78-.14,3.44-.28,6.89-.44,10.33-.14,3-.25,5.91-.51,8.85,0,.4-.07.79-.13,1.18a1.38,1.38,0,0,1,0,.2c0,.12,0,.09,0,.08a5.08,5.08,0,0,0-.34-.48,1.31,1.31,0,0,0-.69-.33c-.3-.07-.6,0-.9-.11s-.51-.33-.72-.63a7.13,7.13,0,0,0-1.27-1.52,2.33,2.33,0,0,0-3.05-.1,3.63,3.63,0,0,0-1.13,1.21c-.33.66-.25,1.37-1.25,1.16a7.31,7.31,0,0,0-2-.32,5,5,0,0,0-1.88.51.84.84,0,0,1-1.05-.14,2.13,2.13,0,0,0-.62-.4,6.11,6.11,0,0,0-2-.38,4.37,4.37,0,0,0-1.8.15,9.62,9.62,0,0,1-2.22.79c-1.26.1-2.83-.06-3.5-1.28a8.27,8.27,0,0,1-.73-2.86,10.48,10.48,0,0,0-.62-2.7,2.48,2.48,0,0,0-2.23-1.69c-1.2.11-2.06,1.44-2.59,2.39a8.38,8.38,0,0,1-.91,1.85c-.29.31-.61.09-1,.17a.94.94,0,0,0-.55.39c-.35.45-.51,1-.83,1.51a5.9,5.9,0,0,1-1.6,1.55,5.72,5.72,0,0,1-4.45.77,3,3,0,0,1-1-.34c-.43-.26-.42-.61-.44-1.05,0-.82-.1-1.64-.14-2.46,0-.28,0-.56,0-.84l-.15-3.43c-.25-5.94-.42-11.9-.81-17.84a3.79,3.79,0,0,0-.05-.58c-.06-.35-.71-.57-.76-.11-.22,1.82-.24,3.67-.32,5.49-.15,3.07-.28,6.13-.4,9.2-.1,2.57-.2,5.14-.28,7.71,0,.91-.05,1.83-.05,2.74s.07,1.84,0,2.76a1.09,1.09,0,0,1-.05.44c-.08.18,0,.19-.15.12s-.28-.41-.39-.52a1.54,1.54,0,0,0-.59-.38,5,5,0,0,0-1.33-.15,1.9,1.9,0,0,1-1.16-.56c-.59-.55-1-1.25-1.62-1.79a2.19,2.19,0,0,0-1.83-.6c-1,.19-1.5,1.14-2,1.92a2.4,2.4,0,0,1-1.3,1.15c-.64.16-1-.65-1.42-1-.93-.65-1.88-.09-2.81.24a5.46,5.46,0,0,1-2.07.34,3.73,3.73,0,0,1-2-.82A5.43,5.43,0,0,0,267,82c-1.14,0-1.7.78-2.51,1.43a3.81,3.81,0,0,1-3.62.33c-2.07-.68-3.05-2.35-3.68-4.33a13.33,13.33,0,0,0-.91-2.87,2.37,2.37,0,0,0-2.52-1,2.45,2.45,0,0,0-.95.94,5.24,5.24,0,0,0-1,1.63c-.08.26-.06.47-.32.61s-.32.08-.46.19a2.28,2.28,0,0,0-.67,1.09,15.91,15.91,0,0,0-.59,1.49c-.2.61-.33,1.23-1.08,1.26a4.32,4.32,0,0,0-1.39.07c-.47.18-.59.57-.91.92s-1.35.36-1.87.38-1.9.17-2.23-.39A5.58,5.58,0,0,1,242,81.9c-.11-.76-.2-1.53-.27-2.29-.27-2.8-.4-5.61-.59-8.42s-.4-5.84-.59-8.76c-.1-1.42-.19-2.84-.28-4.26,0-.44-.92-.62-1-.11-.44,6.24-.79,12.49-1.13,18.74-.08,1.55-.09,3.1-.17,4.65,0,.41-.05.81-.08,1.21a3.67,3.67,0,0,0-.11.92l-.06.19c.28.1.35.08.21-.07a1.27,1.27,0,0,0-.23-.34,2,2,0,0,0-.58-.51,3.22,3.22,0,0,0-1.35-.41,2.05,2.05,0,0,1-1-.2c-.28-.19-.39-.6-.55-.88A3,3,0,0,0,232,79.82a2.16,2.16,0,0,0-2.2,1.79c-.23.73-.41,1.35-1.28,1.45s-1.67.07-2.49.1c-.67,0-.36.88.2.86.76,0,1.53,0,2.29-.09a2.35,2.35,0,0,0,1.54-.54c.73-.72.55-2.43,1.69-2.7,1.32-.31,1.63,1.34,2.32,2a2.35,2.35,0,0,0,1.48.57,1.79,1.79,0,0,1,1.56.75c.56.79,1.47.81,1.68-.24A27.5,27.5,0,0,0,239,79c.1-3.25.33-6.5.52-9.75.22-3.65.43-7.3.69-10.94l-1-.11c.39,6,.82,11.92,1.21,17.89.09,1.45.2,2.9.36,4.35.08.64.16,1.28.26,1.92a4.69,4.69,0,0,0,.45,1.81c.61,1,2.21.87,3.2.83a10.51,10.51,0,0,0,1.68-.17c.62-.14.72-.58,1.11-1s1-.17,1.56-.21a1.49,1.49,0,0,0,1.11-.61,6.58,6.58,0,0,0,.59-1.51,12.11,12.11,0,0,1,.65-1.53c.25-.45.74-.35,1-.75s.28-1,.56-1.38.93-1.64,1.65-1.46.92.77,1.11,1.43c.52,1.82,1,3.76,2.34,5.18a6.26,6.26,0,0,0,5.78,1.76,3.34,3.34,0,0,0,1.24-.64,7.15,7.15,0,0,1,1.37-1.15c1.3-.59,2.55.8,3.55,1.42a4.51,4.51,0,0,0,3.46.51,10.38,10.38,0,0,0,1.63-.54,2,2,0,0,1,.83-.22c.47,0,.64.37.92.67a1.76,1.76,0,0,0,2.59.07c.78-.68,1.07-2,2-2.46s1.54.42,2.05,1A5.37,5.37,0,0,0,285.36,85a3.18,3.18,0,0,0,1.18.23,1.89,1.89,0,0,1,.85.11c.25.15.36.48.57.68.44.41,1.14.48,1.37-.17a4.63,4.63,0,0,0,.06-1.7c0-1.06,0-2.12,0-3.18,0-2.06.13-4.12.21-6.18.2-5.59.35-11.2.74-16.79,0-.24,0-.49.06-.74l-.76-.11s0,0,0,.11a2.86,2.86,0,0,0,0,.42c0,.43.05.85.07,1.27l.21,4.2c.17,3.54.32,7.08.48,10.61.12,2.6.24,5.2.38,7.8a4,4,0,0,0,.28,1.79,2.4,2.4,0,0,0,1.4.9,6.44,6.44,0,0,0,4.16-.06A6.22,6.22,0,0,0,299.62,82a6.67,6.67,0,0,0,.45-.72,3.57,3.57,0,0,1,.43-.85c.28-.29.6-.1.94-.17a1.06,1.06,0,0,0,.66-.46,15.32,15.32,0,0,0,.81-1.68,5.87,5.87,0,0,1,1.42-1.86c1.39-1.13,2.21.59,2.46,1.77.37,1.78.27,4,1.7,5.4a4.8,4.8,0,0,0,3.49,1,4,4,0,0,0,1.75-.43,4.17,4.17,0,0,1,2.4-.51,3.6,3.6,0,0,1,2.07.53c.44.38.74.72,1.39.55a14.56,14.56,0,0,1,1.86-.64,3.63,3.63,0,0,1,1.23,0c.41.07.79.26,1.2.33,1.33.22,1.27-1.35,2-2.06a2.19,2.19,0,0,1,2-.88,3.4,3.4,0,0,1,1.67,1.53c.28.4.57,1,1.05,1.14.63.25,1.25-.08,1.73.54s1.14.79,1.3-.09a24.73,24.73,0,0,0,.26-2.73c.1-1.49.18-3,.26-4.48.31-6.09.4-12.21.83-18.3a3.05,3.05,0,0,1,.05-.52l-.72-.16a50.12,50.12,0,0,1,.55,6.47c.21,3.44.41,6.88.67,10.32.12,1.7.29,3.4.45,5.09s.2,4,1.77,5.09a2.27,2.27,0,0,0,2,.32,1.66,1.66,0,0,0,.76-.54c.17-.21.26-.43.52-.55a1.16,1.16,0,0,1,.93.06c.71.28,1.5.79,2.24.3a.93.93,0,0,0,.43-.77c0-.26-.06-.59.25-.69a4.42,4.42,0,0,1,.63,0c1-.12.58-1.13,1-1.75s1.37-.88,1.9-1.48a4.91,4.91,0,0,0,.62-1.12c.34-.67,1.08-1,1.65-.35a4.82,4.82,0,0,1,.63,1.87c.15.66.3,1.32.46,2,.07.29.46.34.39,0Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "288.909px 71.5713px 0px",
          }}
          id="elxd3kkfnp3zf"
          className="animable"
        />
        <path
          d="M348.62,91.56H229.8a4.24,4.24,0,0,1-4.24-4.24V56.47a4.24,4.24,0,0,1,4.24-4.24H348.62a4.24,4.24,0,0,1,4.24,4.24V87.32A4.24,4.24,0,0,1,348.62,91.56ZM229.8,53.16a3.31,3.31,0,0,0-3.3,3.31V87.32a3.31,3.31,0,0,0,3.3,3.31H348.62a3.31,3.31,0,0,0,3.3-3.31V56.47a3.31,3.31,0,0,0-3.3-3.31Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "289.21px 71.895px 0px",
          }}
          id="elcer5ypm4y74"
          className="animable"
        />
        <polygon
          points="244.37 138.48 243.37 138.48 243.37 126.27 288.9 90.7 289.52 91.49 244.37 126.76 244.37 138.48"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "266.445px 114.59px 0px",
          }}
          id="elzggpztjylg"
          className="animable"
        />
        <circle
          cx={243.87}
          cy={138.48}
          r={2.15}
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "243.87px 138.48px 0px",
          }}
          id="elx38txn8mvc"
          className="animable"
        />
      </g>
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
)
export default CardiologistAnimated
